/* ============================================================
   WINDOWS 98 — Full OS Desktop for Shopify Craft
   Fetch + Inject edition (no iframes — bypasses Shopify's
   X-Frame-Options header that caused "refused to connect")
   ============================================================

   HOW IT WORKS
   ────────────
   When a visitor lands on your store they see the full Win98
   desktop. Clicking a desktop icon fetches that Shopify page
   with the browser's built-in fetch(), pulls out the <main>
   content, and injects it into a draggable window on the
   desktop. All your store CSS is already loaded on the page,
   so everything looks correct. Links inside windows are
   intercepted so navigation happens within the window.
   Add-to-cart forms are handled via Shopify's /cart/add.js
   AJAX endpoint. The page itself NEVER scrolls.

   ============================================================ */

(function () {
  'use strict';

  /* ============================================================
     CONFIGURATION — edit to match your store
     ============================================================ */
  const CFG = {
    storeName: 'GWAK PRODUCTIONS',

    // ── Email/SMS signup popup — wording ─────────────────────────
    // Edit any of these lines to change what customers see in the
    // popup. Just change the text between the quotes — leave the
    // quotes and commas exactly where they are.
    newsletterPopup: {
      headline:       'GWAK PRODUCTIONS',
      body:            'Sign up for 10% off your first Merch order — plus exclusive drops and early access.',
      emailPlaceholder: 'your@email.com',
      phonePlaceholder: 'Phone number (optional)',
      smsConsentText:  'Also text me exclusive drops & offers. Msg & data rates may apply, frequency varies. Consent isn\'t required to purchase. Reply STOP anytime to opt out.',
      buttonLabel:     'Subscribe',
      skipLabel:       'No thanks',
      // {code} gets swapped for the discountCode value below automatically.
      successText:     'You\'re in! Use code {code} for 10% off Merch.',
      discountCode:    'GWAK10',
      // Small pill shown above the headline to draw the eye. Leave blank
      // ('') to hide it entirely.
      badgeText:       '10% OFF MERCH',
    },

    bootScreen: true,   // show boot animation on first visit

    // ── Boot screen image ────────────────────────────────────────
    // Upload your GWAK Productions boot image to Shopify Assets
    // and paste the CDN URL here. It will fill the entire boot
    // screen instead of the plain black background.
    bootScreenImage: 'https://cdn.shopify.com/s/files/1/0687/7675/5418/files/ChatGPT_Image_May_23_2026_08_16_56_PM.png?v=1779585535',

    // ── Boot startup sound ───────────────────────────────────────
    // Plays the classic Windows 98 startup chord when the boot
    // screen appears. Set to '' to disable.
    bootSoundUrl: 'https://archive.org/download/windows-98-startup/Windows%2098%20Startup.mp3',
    // ─────────────────────────────────────────────────────────────

    // ── Screensaver ──────────────────────────────────────────────
    // After this many milliseconds of mouse inactivity the GWAK
    // logo screensaver kicks in (20 seconds = 20000 ms).
    screensaverDelay: 20000,

    // Paste your Shopify CDN URL for the GWAK logo PNG here.
    // In Shopify Admin → Online Store → Themes → Edit code → Assets,
    // upload "gwak-logo.png", then copy its URL from the browser
    // address bar after clicking the file, and paste it below.
    // The image should be the logo on a WHITE background — the
    // screensaver inverts + colorizes it automatically so the
    // white disappears on the black screensaver backdrop.
    screensaverLogo: 'https://cdn.shopify.com/s/files/1/0687/7675/5418/files/IMG_9011_2.jpg?v=1779577432',

    // ── Windows 98 error sound ───────────────────────────────────
    // Upload chord.wav to Shopify Assets and paste the CDN URL here.
    // Download the original from: search "Windows 98 chord.wav download"
    // then upload to Shopify Admin → Online Store → Themes → Edit code → Assets
    virusSoundUrl: 'https://archive.org/download/windowsxperror1/windows_xp_error%20%281%29.mp3',

    // ── DO NOT CLICK — GWAK sound ────────────────────────────────
    // Paste the Shopify CDN URL for your audio clip here.
    // HOW TO SET UP:
    //   1. Go to y2mate.com (or any YouTube-to-MP3 site)
    //   2. Paste: https://www.youtube.com/watch?v=dZUwIpWCRPI
    //   3. Download the MP3, then trim it to start at 9 seconds
    //      (use any free audio editor, e.g. mp3cut.net)
    //   4. In Shopify Admin → Settings → Files, upload the MP3
    //   5. Click the file to copy its CDN URL, then paste it below
    gwakSoundUrl: 'https://cdn.shopify.com/s/files/1/0687/7675/5418/files/Bart_speaking_through_several_megaphones_mp3cut.net.mp3?v=1783602686',

    // ── Gay Mode music ───────────────────────────────────────────
    // This plays on ALL devices (including iPhone) when Gay Mode activates.
    // HOW TO SET UP:
    //   1. Go to mp3cut.net (or any audio trimmer)
    //   2. Paste: https://www.youtube.com/watch?v=paq6sVkkEg0
    //      (or download the MP3 first via y2mate.com, then trim it)
    //   3. Trim to start at 12 seconds
    //   4. In Shopify Admin → Settings → Files, upload the MP3
    //   5. Click the file to copy its CDN URL, paste it below
    gayModeSoundUrl: 'https://cdn.shopify.com/s/files/1/0687/7675/5418/files/Why_are_you_gay_full_interview_lgbtq_gay_mp3cut.net.mp3?v=1783601404',

    // ── Gay Mode unicorn sticker image ───────────────────────────
    // Upload the unicorn PNG sticker to Shopify Admin → Settings → Files,
    // then paste the CDN URL here. The image will fly across the screen
    // when Gay Mode activates. Leave '' to use the canvas-drawn unicorn.
    unicornImageUrl: '',
    // ─────────────────────────────────────────────────────────────
    // ─────────────────────────────────────────────────────────────

    // ── Recycle Bin — Modeling Photos ────────────────────────────
    // Add your photos here. Each entry needs:
    //   name: the filename shown in the folder (make it look deleted/real)
    //   url:  the Shopify CDN URL for the image
    //         (upload each photo to Assets, then copy its CDN URL)
    // Example:
    //   { name: 'DSC_0042.jpg', url: 'https://cdn.shopify.com/s/files/.../photo.jpg' }
    // ── Heather folder thumbnail ─────────────────────────────────
    // Upload your image to Shopify Assets and paste the CDN URL here.
    // This image shows as the thumbnail inside the fake media player.
    heatherThumb: 'https://cdn.shopify.com/s/files/1/0687/7675/5418/files/IMG_9399.jpg?v=1779580191',
    // ─────────────────────────────────────────────────────────────

    modelingPhotos: [
      { name: 'IMG_9395.png', url: 'https://cdn.shopify.com/s/files/1/0687/7675/5418/files/IMG_9395.png?v=1779578365' },
      { name: 'IMG_9396.png', url: 'https://cdn.shopify.com/s/files/1/0687/7675/5418/files/IMG_9396.png?v=1779578365' },
      { name: 'IMG_9397.png', url: 'https://cdn.shopify.com/s/files/1/0687/7675/5418/files/IMG_9397.png?v=1779578364' },
      { name: 'IMG_9398.png', url: 'https://cdn.shopify.com/s/files/1/0687/7675/5418/files/IMG_9398.png?v=1779578363' },
    ],
    // ─────────────────────────────────────────────────────────────

    // Tabs shown across the top of the "My Shop" window. The first tab
    // loads automatically when the window opens; clicking any other tab
    // swaps the collection shown without closing/reopening the window.
    // Edit label/url pairs here to add, remove, or reorder tabs.
    // "color" gives each tab its own accent (top stripe when unselected,
    // full fill when selected) so the row is easy to scan at a glance.
    // "icon" is an optional small emoji shown before the label.
    shopTabs: [
      { label: 'Gwak Shop',  url: '/collections/catalog',           color: '#000080', icon: '🏠' },
      { label: 'Merch',      url: '/collections/new-merch',         color: '#cc6600', icon: '🛍️' },
      { label: 'Spray Cans', url: '/collections/spray-cans-1',      color: '#008080', icon: '🎨' },
      { label: 'Tech Decks', url: '/collections/tech-decks',        color: '#7b2fbf', icon: '🛹' },
      { label: 'Cigs',       url: '/collections/cigs',              color: '#a30000', icon: '🚬' },
      { label: 'Cut Outs',   url: '/collections/cardboard-cutouts', color: '#1a7a1a', icon: '✂️' },
      { label: 'Gwak Sauce', url: '/collections/jumbo-gwak-sauces', color: '#e25822', icon: '🌶️' },
      { label: 'Gwak Pops',  url: '/collections/gwak-pops',         color: '#d6336c', icon: '🍭' },
    ],

    // Tabs shown across the top of the Merch icon window (same format as
    // shopTabs above). Add a line per merch category — label + collection url.
    merchTabs: [
      { label: 'Tees',    url: '/collections/tees',    color: '#cc6600', icon: '👕' },
      { label: 'Hoodies', url: '/collections/hoodies', color: '#7b2fbf', icon: '🧥' },
    ],

    // Any product carrying this Shopify tag gets the freight-shipping notice
    // shown right under its price (see addFreightNotice). Add the tag to a
    // product in Shopify Admin → Products → (product) → Tags.
    freightTag: 'freight-shipping',
    freightEmail: 'gwakproductions@gmail.com',

    // Desktop icons — LEFT side column.
    // url: any Shopify path  |  action: built-in dialog name
    icons: [
      // ── My Computer — authentic Win98 pixel-art icon ─────────────
      { id: 'store', label: 'My Shop', action: 'myShop',
        svg: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" width="48" height="48">
          <image href="https://win98icons.alexmeub.com/icons/png/computer_explorer_cool-0.png"
                 x="0" y="0" width="32" height="32"
                 style="image-rendering:pixelated;image-rendering:crisp-edges"/>
        </svg>`
      },

      // ── Merch — shopping bag icon, links to merch collection ────
      { id: 'merch', label: 'Merch', action: 'merch',
        badge: 'NEW', highlight: true,
        svg: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" width="48" height="48">
          <image href="https://win98icons.alexmeub.com/icons/png/briefcase-1.png"
                 x="0" y="0" width="32" height="32"
                 style="image-rendering:pixelated;image-rendering:crisp-edges"/>
        </svg>`
      },

      // ── Online Course — graduation cap / mortarboard icon ────────
      // TODO: swap this url for the real product/page path once you
      // tell me what it is — this is just a placeholder guess so the
      // icon shows up now. "badge"/"highlight" give it the same
      // glowing "NEW" treatment as Merch, so it stands out.
      { id: 'course', label: 'Online Course', url: '/products/online-course-by-gwak',
        badge: 'NEW', highlight: true, noAutoOpen: true,
        svg: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 56 52" width="54" height="50">
          <defs>
            <linearGradient id="capTop" x1="0" y1="0" x2="1" y2="1">
              <stop offset="0%" stop-color="#2b2b52"/>
              <stop offset="100%" stop-color="#14142b"/>
            </linearGradient>
            <linearGradient id="capBase" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stop-color="#3a3a66"/>
              <stop offset="100%" stop-color="#1a1a33"/>
            </linearGradient>
          </defs>

          <!-- Drop shadow -->
          <ellipse cx="28" cy="46" rx="18" ry="4" fill="rgba(0,0,0,0.30)"/>

          <!-- Cap base (head sits under the board) -->
          <path d="M 18 24 L 38 24 L 36 38 Q 28 42 20 38 Z" fill="url(#capBase)" stroke="#0a0a1a" stroke-width="0.6"/>

          <!-- Mortarboard top (diamond) -->
          <polygon points="28,6 52,19 28,32 4,19" fill="url(#capTop)" stroke="#0a0a1a" stroke-width="0.8"/>
          <!-- Sheen highlight -->
          <polygon points="28,6 40,12.5 28,19 16,12.5" fill="rgba(255,255,255,0.14)"/>

          <!-- Center button -->
          <circle cx="28" cy="19" r="2.6" fill="#ffd54a" stroke="#b8860b" stroke-width="0.5"/>

          <!-- Tassel string + strands -->
          <path d="M 28 19 L 44 19 L 42 30" fill="none" stroke="#ffd54a" stroke-width="1.4" stroke-linecap="round"/>
          <g stroke="#e8b923" stroke-width="1.1" stroke-linecap="round">
            <line x1="42" y1="30" x2="39" y2="37"/>
            <line x1="42" y1="30" x2="42" y2="38"/>
            <line x1="42" y1="30" x2="45" y2="37"/>
          </g>
          <circle cx="42" cy="30" r="1.6" fill="#ffd54a"/>
        </svg>`
      },

      { id: 'cart', label: 'Cart', glyph: '🛒', url: '/cart' },


      // ── Outlook Express (IE "e" + envelope — classic Win98 email icon)
      { id: 'contact', label: 'Contact', url: '/pages/contact',
        svg: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 44" width="54" height="42">
          <defs>
            <linearGradient id="eg" x1="0.2" y1="0" x2="0.8" y2="1">
              <stop offset="0%"   stop-color="#6699ff"/>
              <stop offset="100%" stop-color="#0033bb"/>
            </linearGradient>
            <linearGradient id="orb" x1="0" y1="0.5" x2="1" y2="0.5">
              <stop offset="0%"   stop-color="#4488ff"/>
              <stop offset="42%"  stop-color="#ddaa00"/>
              <stop offset="58%"  stop-color="#ddaa00"/>
              <stop offset="100%" stop-color="#4488ff"/>
            </linearGradient>
          </defs>
          <!-- IE-style bold italic "e" -->
          <text x="21" y="28" text-anchor="middle"
                font-family="Arial,Helvetica,sans-serif"
                font-size="34" font-weight="bold" font-style="italic"
                fill="url(#eg)">e</text>
          <!-- Highlight pass on "e" -->
          <text x="20" y="23" text-anchor="middle"
                font-family="Arial,Helvetica,sans-serif"
                font-size="34" font-weight="bold" font-style="italic"
                fill="#aaccff" opacity="0.22">e</text>
          <!-- Orbital ring (tilted ellipse — yellow+blue, like IE logo) -->
          <ellipse cx="21" cy="21" rx="20" ry="11"
                   fill="none" stroke="url(#orb)" stroke-width="3.5"
                   transform="rotate(-32,21,21)"/>
          <!-- Envelope (lower-right corner) -->
          <rect x="28" y="30" width="19" height="13" rx="1" fill="#ffffc4" stroke="#b09020" stroke-width="0.8"/>
          <!-- Envelope V-flap -->
          <polygon points="28,30 37.5,37 47,30" fill="#f0e070" stroke="#b09020" stroke-width="0.8"/>
          <!-- Red stamp/badge -->
          <rect x="41" y="31" width="5" height="4" fill="#cc0000"/>
          <!-- Body lines -->
          <line x1="30" y1="39" x2="45" y2="39" stroke="#c0a030" stroke-width="0.8" opacity="0.55"/>
          <line x1="30" y1="41" x2="43" y2="41" stroke="#c0a030" stroke-width="0.8" opacity="0.55"/>
        </svg>`
      },

      { id: 'commissions', label: 'Hire Me', glyph: '🎨', action: 'commissions' },

      // ── YouTube (2012 logo, unchanged) ───────────────────────────
      { id: 'youtube', label: 'YouTube', action: 'youtube',
        svg: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 90 62" width="54" height="38">
          <rect x="2" y="2" width="86" height="58" rx="13" fill="rgba(0,0,0,0.25)"/>
          <rect x="0" y="0" width="86" height="58" rx="12" fill="#CC0000"/>
          <rect x="0" y="0" width="86" height="29" rx="12" fill="url(#ytg)"/>
          <defs>
            <linearGradient id="ytg" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stop-color="#FF2222" stop-opacity="0.55"/>
              <stop offset="100%" stop-color="#CC0000" stop-opacity="0"/>
            </linearGradient>
          </defs>
          <polygon points="34,17 58,30 34,43" fill="rgba(0,0,0,0.3)" transform="translate(2,2)"/>
          <polygon points="34,17 58,30 34,43" fill="#FFFFFF"/>
        </svg>`
      },

      // ── Egg Game — PlayStation DualShock controller icon ─────────────
      { id: 'eggGame', label: 'GAMES', action: 'eggGame',
        svg: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 56 56" width="56" height="56">
          <defs>
            <!-- Classic Win95 gray palette gradients -->
            <linearGradient id="gbase" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%"   stop-color="#d4d0c8"/>
              <stop offset="100%" stop-color="#a8a090"/>
            </linearGradient>
            <linearGradient id="gbaseL" x1="0" y1="0" x2="1" y2="0">
              <stop offset="0%"   stop-color="#ece8df"/>
              <stop offset="100%" stop-color="#c8c4bc"/>
            </linearGradient>
            <radialGradient id="gstick" cx="40%" cy="30%" r="65%">
              <stop offset="0%"   stop-color="#e0dcd4"/>
              <stop offset="100%" stop-color="#787060"/>
            </radialGradient>
            <radialGradient id="gball" cx="35%" cy="30%" r="65%">
              <stop offset="0%"   stop-color="#f0ece4"/>
              <stop offset="60%"  stop-color="#b0a898"/>
              <stop offset="100%" stop-color="#686058"/>
            </radialGradient>
          </defs>

          <!-- ── Drop shadow ── -->
          <ellipse cx="28" cy="50" rx="20" ry="5" fill="rgba(0,0,0,0.30)"/>

          <!-- ── Controller base — top face (isometric-ish top-down view) ── -->
          <!-- Dark bottom edge (3-D illusion) -->
          <ellipse cx="28" cy="42" rx="22" ry="10" fill="#787060"/>
          <!-- Top face -->
          <ellipse cx="28" cy="38" rx="22" ry="10" fill="url(#gbase)" stroke="#888880" stroke-width="0.6"/>
          <!-- Left highlight bevel -->
          <path d="M 6 38 Q 6 34 28 30 Q 28 34 28 38 Z" fill="rgba(255,255,255,0.28)"/>
          <!-- Right shadow bevel -->
          <path d="M 50 38 Q 50 34 28 30 Q 28 34 28 38 Z" fill="rgba(0,0,0,0.12)"/>
          <!-- Top highlight rim -->
          <ellipse cx="28" cy="30" rx="22" ry="10" fill="none"
                   stroke="rgba(255,255,255,0.45)" stroke-width="1.2"/>

          <!-- ── Joystick base collar ── -->
          <ellipse cx="28" cy="28" rx="7" ry="4" fill="#989088" stroke="#686058" stroke-width="0.6"/>
          <ellipse cx="28" cy="27" rx="6" ry="3" fill="#b0a898"/>

          <!-- ── Joystick shaft ── -->
          <path d="M 24 27 L 23 10 L 33 10 L 32 27 Z"
                fill="url(#gstick)" stroke="#686058" stroke-width="0.5"/>
          <!-- Shaft highlight -->
          <path d="M 25 27 L 24.5 10 L 26 10 L 26.5 27 Z" fill="rgba(255,255,255,0.30)"/>

          <!-- ── Stick ball (top) ── -->
          <circle cx="28" cy="9"  r="7.5" fill="#888880" stroke="#585048" stroke-width="0.5"/>
          <circle cx="28" cy="8"  r="6.5" fill="url(#gball)"/>
          <circle cx="25" cy="5"  r="2.5" fill="rgba(255,255,255,0.50)"/>

          <!-- ── Fire button (right side of base) ── -->
          <!-- Button surround -->
          <ellipse cx="42" cy="37" rx="5.5" ry="3.5" fill="#686058"/>
          <ellipse cx="42" cy="36" rx="5"   ry="3"   fill="#cc1111"/>
          <!-- Button highlight -->
          <ellipse cx="40.5" cy="35" rx="2" ry="1.2" fill="rgba(255,255,255,0.40)"/>

          <!-- ── Small secondary button (left side) ── -->
          <ellipse cx="14" cy="37" rx="4" ry="2.5" fill="#686058"/>
          <ellipse cx="14" cy="36" rx="3.5" ry="2" fill="#a0a090"/>
          <ellipse cx="13" cy="35.2" rx="1.4" ry="0.9" fill="rgba(255,255,255,0.35)"/>
        </svg>`
      },

      // ── GWAK Word sound button ────────────────────────────────────
      { id: 'gwakWord', label: 'DO NOT CLICK', action: 'gwakWord',
        svg: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 56 52" width="56" height="52">
          <defs>
            <linearGradient id="ctnfill" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%"   stop-color="#ffe84d"/>
              <stop offset="100%" stop-color="#e6a800"/>
            </linearGradient>
          </defs>

          <!-- Drop shadow -->
          <polygon points="28,6 55,52 1,52"
                   fill="rgba(0,0,0,0.32)" transform="translate(2,3)"/>

          <!-- Outer black border triangle -->
          <polygon points="28,1 56,51 0,51"
                   fill="#111" stroke="#000" stroke-width="1" stroke-linejoin="round"/>

          <!-- Yellow filled triangle (inset) -->
          <polygon points="28,6 52,49 4,49"
                   fill="url(#ctnfill)"/>

          <!-- Inner top highlight -->
          <polygon points="28,9 46,44 10,44"
                   fill="rgba(255,255,255,0.18)"/>

          <!-- Exclamation mark — body -->
          <rect x="24.5" y="16" width="7" height="18" rx="3.5" fill="#111"/>
          <!-- Exclamation mark — dot -->
          <circle cx="28" cy="41.5" r="4" fill="#111"/>
        </svg>`
      },

      { id: 'recycle', label: 'Recycle', action: 'recycleBin',
        defaultPos: (d) => ({ x: d.clientWidth - 84, y: d.clientHeight - 100 }),
        svg: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" width="48" height="48">
          <image href="https://win98icons.alexmeub.com/icons/png/recycle_bin_full_cool-0.png"
                 x="0" y="0" width="32" height="32"
                 style="image-rendering:pixelated;image-rendering:crisp-edges"/>
        </svg>`
      },

    ],

    // Quick-Launch icons next to the Start button
    quickLaunch: [
      { label: 'Show Desktop', glyph: '🖥️',  action: 'showDesktop'   },
      { label: 'Browse Art',   glyph: '🖼️',  url: '/collections/catalog' },
      { label: 'View Cart',    glyph: '🛒',  url: '/cart'            },
    ],

    // Start menu nav links — the fun/shopping stuff visitors actually
    // want to click, kept right up top.
    navItems: [
      { label: 'Home',    glyph: '🏠', url: '/'                },
      { label: 'All Art', glyph: '🖼️',  url: '/collections/catalog' },
      { label: 'Cart',    glyph: '🛒', url: '/cart'            },
      { label: 'Contact', glyph: '✉️',  url: '/pages/contact'  },
    ],

    // Policy pages — kept in the Start menu rather than as desktop
    // icons, and grouped at the very bottom of the menu, below the fun
    // stuff (Subscribe, Gay Mode) — visitors need these to exist and be
    // reachable, but they're not what anyone's excited to click.
    legalItems: [
      { label: 'Privacy Policy',    glyph: '🔒', url: '/policies/privacy-policy'    },
      { label: 'Terms of Service',  glyph: '📜', url: '/policies/terms-of-service'  },
      { label: 'Refund Policy',     glyph: '↩️', url: '/policies/refund-policy'     },
    ],

    defaultW: 680,
    defaultH: 480,

    // Set to false to NOT auto-open a window when the page loads
    autoOpen: false,
  };

  /* ============================================================
     DOM HELPER
     ============================================================ */
  function h(tag, props, ...kids) {
    const el = document.createElement(tag);
    if (props) Object.entries(props).forEach(([k, v]) => {
      if (k === 'cls')      el.className = v;
      else if (k === 'css') Object.assign(el.style, v);
      else if (k[0] === '$') el.addEventListener(k.slice(1), v);
      else el.setAttribute(k, v);
    });
    kids.flat().forEach(k => {
      if (k == null) return;
      el.appendChild(typeof k === 'string' ? document.createTextNode(k) : k);
    });
    return el;
  }

  /* ============================================================
     MOBILE DETECTION
     ============================================================ */
  const isMobile = () => window.matchMedia('(max-width: 1024px)').matches;

  /* ============================================================
     WINDOW MANAGER STATE
     ============================================================ */
  let topZ    = 100;
  let cascade = 0;
  let desktop, tbWindowsEl, smEl;

  // Map: windowId → { el, tbBtn, minified, maxed, restore, history, histIdx }
  const wins = new Map();

  function nextPos() {
    const cx = Math.max(90, Math.round((window.innerWidth  - CFG.defaultW) / 2) + cascade);
    const cy = Math.max(10, Math.round((window.innerHeight - 36 - CFG.defaultH) / 2) + cascade);
    cascade = (cascade + 28) % 140;
    return { x: cx, y: cy };
  }

  function bringToFront(winEl) {
    topZ++;
    winEl.style.zIndex = topZ;
    wins.forEach(s => s.el.classList.add('w98-win--inactive'));
    winEl.classList.remove('w98-win--inactive');
    // Mark taskbar button active
    wins.forEach((s, id) => {
      if (s.el === winEl) s.tbBtn && s.tbBtn.classList.add('w98-active');
      else s.tbBtn && s.tbBtn.classList.remove('w98-active');
    });
  }

  /* ============================================================
     FETCH PAGE CONTENT
     Fetches a Shopify URL, extracts the <main> element, and
     returns it as a DocumentFragment ready to inject.
     ============================================================ */
  async function fetchPage(url) {
    const resp = await fetch(url, { credentials: 'same-origin' });
    if (!resp.ok) throw new Error('Server returned ' + resp.status);

    const html  = await resp.text();
    const parser = new DOMParser();
    const doc   = parser.parseFromString(html, 'text/html');

    // Inject any inline <style> blocks unique to that page
    doc.querySelectorAll('head style').forEach(st => {
      // Avoid duplicating styles already on the page
      const text = st.textContent.trim().slice(0, 60);
      const already = Array.from(document.head.querySelectorAll('style'))
        .some(s => s.textContent.trim().slice(0, 60) === text);
      if (!already) document.head.appendChild(st.cloneNode(true));
    });

    // Inject any LINKED stylesheets this page needs but the parent Win98
    // page doesn't already have — e.g. the CSS for the product zoom/media
    // modal, which only loads on real product pages. Without this, elements
    // like <product-modal> can technically "open" (their JS runs fine) but
    // have no styling to actually appear on screen.
    doc.querySelectorAll('head link[rel="stylesheet"]').forEach(link => {
      const href = link.getAttribute('href');
      if (!href) return;
      let absHref;
      try { absHref = new URL(href, url).href; } catch { return; }
      const alreadyLoaded =
        Array.from(document.styleSheets).some(ss => ss.href === absHref) ||
        Array.from(document.querySelectorAll('link[rel="stylesheet"]')).some(l => l.href === absHref);
      if (!alreadyLoaded) {
        const freshLink = document.createElement('link');
        freshLink.rel = 'stylesheet';
        freshLink.href = href;
        document.head.appendChild(freshLink);
      }
    });

    // Find the main content region (Shopify / Craft conventions)
    const main =
      doc.getElementById('MainContent') ||
      doc.querySelector('main')          ||
      doc.querySelector('.main-page-content') ||
      doc.querySelector('[role="main"]') ||
      doc.body;

    const frag = document.createDocumentFragment();
    Array.from(main.childNodes).forEach(n => frag.appendChild(document.importNode(n, true)));
    return frag;
  }

  /* ============================================================
     CLEAN UP DUPLICATE MODALS
     Elements like <product-modal> and <quick-add-modal> relocate
     themselves to be a direct child of <body> when they connect
     (a common trick so they can escape any parent's clipping or
     z-index). If the same product or quick-add target is loaded
     more than once in a browsing session — e.g. revisiting the
     same product — this leaves stale duplicate copies sitting in
     the page forever, each one potentially holding its own large
     product image in memory. This keeps only one copy per id
     (favoring whichever is currently open/visible), so the page
     doesn't accumulate clutter the longer someone browses —
     most noticeable on mobile, where memory is more limited.
     ============================================================ */
  function cleanupDuplicateModals() {
    const seen = new Map(); // id -> element currently being kept
    const candidates = Array.from(document.body.children).filter(el =>
      el.parentElement === document.body &&
      el.id &&
      (el.tagName === 'PRODUCT-MODAL' || el.tagName === 'QUICK-ADD-MODAL')
    );

    candidates.forEach(el => {
      const prev = seen.get(el.id);
      if (!prev) {
        seen.set(el.id, el);
        return;
      }
      // Duplicate found. Never remove whichever copy is currently open;
      // otherwise keep the newest (later in document order) and drop the
      // older, stale one.
      if (prev.hasAttribute('open') && !el.hasAttribute('open')) {
        el.remove();
      } else {
        prev.remove();
        seen.set(el.id, el);
      }
    });
  }

  /* ============================================================
     LOAD URL INTO AN EXISTING WINDOW
     ============================================================ */
  async function loadUrl(winId, url, pushHistory = true) {
    const s = wins.get(winId);
    if (!s) return;

    const area    = s.el.querySelector('.w98-win__content');
    const addrEl  = s.el.querySelector('.w98-win__addr-display');
    const backBtn = s.el.querySelector('.w98-win__back');
    const fwdBtn  = s.el.querySelector('.w98-win__fwd');

    // Loading state
    area.innerHTML = '';
    area.appendChild(h('div', { cls: 'w98-win__loader' }, '⏳  Loading…'));

    try {
      const frag = await fetchPage(url);
      area.innerHTML = '';
      area.appendChild(frag);
      area.scrollTop = 0;

      // Update address bar
      if (addrEl) addrEl.textContent = new URL(url, location.origin).pathname;

      // Push history
      if (pushHistory) {
        s.history = s.history.slice(0, s.histIdx + 1);
        s.history.push(url);
        s.histIdx = s.history.length - 1;
      }

      // Update back/fwd button states
      if (backBtn) backBtn.disabled = s.histIdx <= 0;
      if (fwdBtn)  fwdBtn.disabled  = s.histIdx >= s.history.length - 1;

      // Wire up all links and forms inside the injected content
      // Move "Shipping calculated at checkout" / Shop Pay line below the buy buttons.
      relocateShippingNote(area);

      wireContent(winId, area);

      // Large/freight pieces: surface the shipping notice up by the price.
      addFreightNotice(area, url);

      // Re-upgrade any Shopify custom elements (product-form, variant-selects…)
      // They use connectedCallback so they self-initialize when injected,
      // but we re-run any inline init scripts just in case. Skip non-JS
      // script types (JSON-LD structured data, application/json, etc.) —
      // re-running those as JavaScript throws a syntax error.
      const SKIP_SCRIPT_TYPES = ['application/ld+json', 'application/json', 'importmap'];
      area.querySelectorAll('script:not([src])').forEach(old => {
        const type = (old.getAttribute('type') || '').toLowerCase();
        if (SKIP_SCRIPT_TYPES.includes(type)) return;
        const fresh = document.createElement('script');
        fresh.textContent = old.textContent;
        old.replaceWith(fresh);
      });

      // Load any external scripts (e.g. product-modal.js) that this page
      // needs but that weren't already loaded on the parent Win98 page.
      // Without this, custom elements like <product-modal> never get
      // registered, so buttons like the image-zoom trigger do nothing.
      // We WAIT for each one to finish loading before moving on, so a
      // person can't click a button before its script has registered —
      // that race condition is what caused "modal.show is not a function".
      const externalScripts = Array.from(area.querySelectorAll('script[src]'));
      await Promise.all(externalScripts.map(old => {
        const src = old.getAttribute('src');
        old.remove();
        if (!src) return Promise.resolve();
        const absSrc = new URL(src, location.origin).href;
        const alreadyLoaded = Array.from(document.scripts).some(s => s.src === absSrc);
        if (alreadyLoaded) return Promise.resolve();
        return new Promise(resolve => {
          const fresh = document.createElement('script');
          fresh.src = src;
          if (old.id) fresh.id = old.id;
          fresh.onload = resolve;
          fresh.onerror = resolve; // don't hang forever if one script 404s
          document.head.appendChild(fresh);
        });
      }));

      // Clear out any stale duplicate <product-modal>/<quick-add-modal>
      // elements left over from a previous visit to this same product or
      // quick-add target, now that any relocation-to-<body> has settled.
      cleanupDuplicateModals();

    } catch (err) {
      area.innerHTML = '';
      area.appendChild(h('div', { css: { padding: '20px' } },
        h('p', { css: { fontWeight: '700', marginBottom: '8px' } }, '⚠️  Could not load page'),
        h('p', { css: { fontSize: '12px' } }, err.message),
        h('p', { css: { fontSize: '11px', color: '#555', marginTop: '8px' } },
          'Try: right-click → Refresh, or close and reopen this window.')
      ));
    }
  }

  /* ============================================================
     SHIPPING NOTE + SHOP PAY LINE PLACEMENT
     The theme prints "Shipping calculated at checkout." right under the
     price. Show it below the Add to cart / payment buttons instead. The
     original is hidden and a copy placed (the theme re-renders the price
     block on variant change and would otherwise bring it back).
     ============================================================ */
  function relocateShippingNote(area) {
    area.classList.remove('w98-tax-moved');
    try {
      const tax  = area.querySelector('.product__tax');
      const form = area.querySelector('product-form');
      const info = area.querySelector('.product__info-container');
      if (!form || !info) return;
      if (area.querySelector('.w98-moved-tax')) return;
      const hasTax = !!(tax && tax.textContent.trim());

      let block = form;
      while (block.parentElement && block.parentElement !== info) block = block.parentElement;
      if (block.parentElement !== info) return;

      if (!document.getElementById('w98-tax-css')) {
        const st = document.createElement('style');
        st.id = 'w98-tax-css';
        st.textContent = '.w98-tax-moved .product__tax:not(.w98-moved-tax){display:none !important}';
        document.head.appendChild(st);
      }

      // The Shop Pay "Pay over time / From $X/mo" line: move the real element
      // (Shopify's script keeps it updated) to sit under the payment buttons.
      let anchor = block;
      const termsEl = area.querySelector('.product__payment-terms') || area.querySelector('shopify-payment-terms');
      if (termsEl) {
        let tb = termsEl;
        while (tb.parentElement && tb.parentElement !== info) tb = tb.parentElement;
        const isolated = tb.parentElement === info && tb !== block &&
                         !tb.contains(form) && !tb.querySelector('.price, product-form');
        if (isolated) {
          tb.style.margin = '12px 0 0';
          anchor.after(tb);
          anchor = tb;
        }
      }

      if (hasTax) {
        const copy = tax.cloneNode(true);
        copy.classList.add('w98-moved-tax');
        copy.removeAttribute('id');
        copy.style.margin = '12px 0 0';
        anchor.after(copy);
        area.classList.add('w98-tax-moved');
      }
    } catch (e) { /* purely cosmetic — never break the page over it */ }
  }

  /* ============================================================
     FREIGHT NOTICE
     Products tagged CFG.freightTag get a visible notice under the
     price instead of leaving the info buried in the description.
     ============================================================ */
  async function addFreightNotice(area, url) {
    if (!CFG.freightTag) return;
    let m;
    try { m = new URL(url, location.origin).pathname.match(/^\/products\/([^\/]+)/); } catch (e) {}
    if (!m) return;

    area.dataset.w98Url = url; // lets us bail if they navigate away mid-fetch
    try {
      const r = await fetch('/products/' + m[1] + '.js', { credentials: 'same-origin' });
      if (!r.ok) return;
      const p = await r.json();
      const want = String(CFG.freightTag).toLowerCase();
      if (!(p.tags || []).some(t => String(t).toLowerCase() === want)) return;
      if (area.dataset.w98Url !== url || area.querySelector('.w98-freight-notice')) return;

      const email = CFG.freightEmail || '';
      const notice = h('div', {
        cls: 'w98-freight-notice',
        css: {
          // Quiet outline only — no fill, inherits the page's own text color.
          background: 'transparent', color: 'inherit',
          border: '1px solid rgba(128,128,128,0.65)', borderRadius: '3px',
          padding: '10px 12px', margin: '14px 0', fontSize: '12px', lineHeight: '1.5',
          maxWidth: '520px', opacity: '0.92',
        }
      },
        h('div', {},
          h('strong', { css: { fontWeight: '600', color: '#f5c542' } }, '*Specialized freight shipping required. '),
          'This piece requires custom crating and transport. Shipping is quoted separately based on the piece and delivery address and is not included in the listed price. Please email ',
          email ? h('a', {
            href: 'mailto:' + email + '?subject=' + encodeURIComponent('Freight quote: ' + (p.title || '')),
            css: { color: '#3ea6ff', textDecoration: 'underline' }
          }, email) : '',
          ' for a quote.'
        )
      );

      // Right after the block holding the price; fall back to the top of the
      // product info column, then the top of the window.
      const price = area.querySelector('.price');
      const info  = area.querySelector('.product__info-container');
      let block = price;
      while (block && info && block.parentElement && block.parentElement !== info) block = block.parentElement;
      if (price && info && block && block.parentElement === info) block.after(notice);
      else if (info) info.prepend(notice);
      else area.prepend(notice);
    } catch (e) { /* notice is optional — never break the page over it */ }
  }

  /* ============================================================
     WIRE UP CONTENT
     Intercepts links and forms inside an injected page so they
     navigate within the window instead of the full browser.
     ============================================================ */
  function wireContent(winId, container) {
    // ── Links ──────────────────────────────────────────────
    container.querySelectorAll('a[href]').forEach(link => {
      // Skip anchors, mailto, tel, external, and checkout
      const href = link.getAttribute('href') || '';
      if (!href || href.startsWith('#') || href.startsWith('mailto:') || href.startsWith('tel:')) return;
      if (link.target === '_blank') return;

      let fullUrl;
      try { fullUrl = new URL(href, location.origin); } catch { return; }

      // External or Shopify checkout (different domain) → open normally
      if (fullUrl.origin !== location.origin) return;
      if (fullUrl.pathname.startsWith('/checkout')) return;

      link.addEventListener('click', e => {
        e.preventDefault();
        loadUrl(winId, fullUrl.pathname + fullUrl.search);
      });
    });

    // ── Add-to-cart forms ──────────────────────────────────
    container.querySelectorAll('form[action*="/cart/add"]').forEach(form => {
      form.addEventListener('submit', async e => {
        e.preventDefault();
        const btn = form.querySelector('[type="submit"]');
        if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }

        try {
          const resp = await fetch('/cart/add.js', {
            method:      'POST',
            body:        new FormData(form),
            credentials: 'same-origin',
          });
          const data = await resp.json();

          if (btn) { btn.disabled = false; btn.textContent = 'Add to cart'; }

          if (data.status && data.status !== 200) {
            showMsg('⚠️  ' + (data.description || 'Could not add item'));
          } else {
            openCartConfirm(winId, data.product_title || 'Your item');
          }
        } catch (err) {
          if (btn) { btn.disabled = false; btn.textContent = 'Add to cart'; }
          showMsg('⚠️  Cart error: ' + err.message);
        }
      });
    });

    // ── Search forms ───────────────────────────────────────
    container.querySelectorAll('form[action="/search"], form[action*="/search"]').forEach(form => {
      form.addEventListener('submit', e => {
        e.preventDefault();
        const q = new FormData(form).get('q') || '';
        if (q) loadUrl(winId, '/search?q=' + encodeURIComponent(q) + '&type=product');
      });
    });

    // ── Cart update / quantity forms ───────────────────────
    container.querySelectorAll('form[action="/cart"]').forEach(form => {
      form.addEventListener('submit', async e => {
        // If the checkout button triggered this, let Shopify handle it normally
        const trigger = e.submitter;
        if (trigger && (trigger.name === 'checkout' || (trigger.getAttribute('href') || '').includes('checkout'))) return;
        e.preventDefault();
        try {
          await fetch('/cart/update.js', {
            method:      'POST',
            body:        new FormData(form),
            credentials: 'same-origin',
          });
          // Reload the cart view in the same window
          loadUrl(winId, '/cart');
        } catch(err) {}
      });
    });

    // ── Image zoom lightbox ────────────────────────────────
    container.querySelectorAll('img').forEach(img => {
      if (!img.src) return;
      img.style.cursor = 'zoom-in';
      img.addEventListener('click', function(e) {
        e.stopPropagation();
        // Build full-size URL (remove Shopify size suffix like _800x)
        var src = img.src.replace(/(_\d+x\d*|_\d*x\d+)(\.\w+)(\?|$)/, '$2$3');
        var overlay = document.createElement('div');
        overlay.style.cssText = [
          'position:fixed;inset:0;z-index:99999;background:rgba(0,0,0,0.85);',
          'display:flex;align-items:center;justify-content:center;cursor:zoom-out;'
        ].join('');
        var zImg = document.createElement('img');
        zImg.src = src;
        zImg.style.cssText = 'max-width:90vw;max-height:90vh;object-fit:contain;box-shadow:0 0 40px rgba(0,0,0,0.8);';
        var closeBtn = document.createElement('button');
        closeBtn.textContent = '✕';
        closeBtn.style.cssText = [
          'position:absolute;top:16px;right:20px;background:none;border:none;',
          'color:#fff;font-size:28px;cursor:pointer;line-height:1;'
        ].join('');
        overlay.appendChild(zImg);
        overlay.appendChild(closeBtn);
        document.body.appendChild(overlay);
        var close = function() { overlay.remove(); };
        overlay.addEventListener('click', close);
        closeBtn.addEventListener('click', close);
        document.addEventListener('keydown', function esc(e) {
          if (e.key === 'Escape') { close(); document.removeEventListener('keydown', esc); }
        });
      });
    });
  }

  /* ============================================================
     OPEN A PAGE WINDOW (fetch-based)
     ============================================================ */
  function openPageWin(id, title, glyph, url) {
    if (wins.has(id)) {
      const s = wins.get(id);
      if (s.minified) restoreWin(id); else bringToFront(s.el);
      return;
    }

    const pos = nextPos();

    /* ── Back / Forward buttons ── */
    const backBtn = h('button', {
      cls: 'w98-win__addr-go', title: 'Back',
      css: { minWidth: '24px' },
      disabled: '',
      '$click': () => {
        const s = wins.get(id);
        if (!s || s.histIdx <= 0) return;
        s.histIdx--;
        loadUrl(id, s.history[s.histIdx], false);
      }
    }, '◀\uFE0E');

    const fwdBtn = h('button', {
      cls: 'w98-win__addr-go w98-win__fwd', title: 'Forward',
      css: { minWidth: '24px' },
      disabled: '',
      '$click': () => {
        const s = wins.get(id);
        if (!s || s.histIdx >= s.history.length - 1) return;
        s.histIdx++;
        loadUrl(id, s.history[s.histIdx], false);
      }
    }, '▶\uFE0E');

    // Give the buttons class refs we can query later
    backBtn.classList.add('w98-win__back');

    const addrDisplay = h('span', { cls: 'w98-win__addr-display' }, url);

    const addrBar = h('div', { cls: 'w98-win__addrbar' },
      backBtn, fwdBtn,
      h('span', { cls: 'w98-win__addr-label' }, 'Address'),
      h('div', { cls: 'w98-win__addr-input' }, addrDisplay),
      h('button', {
        cls: 'w98-win__addr-go',
        '$click': () => loadUrl(id, addrDisplay.textContent)
      }, 'Go')
    );

    const menubar = h('div', { cls: 'w98-win__menubar' },
      ...['File', 'Edit', 'View', 'Favorites', 'Tools', 'Help'].map(m => h('span', {}, m))
    );

    /* ── Scrollable content area ── */
    const contentArea = h('div', { cls: 'w98-win__content' });
    contentArea.appendChild(h('div', { cls: 'w98-win__loader' }, '⏳  Loading…'));

    const statusbar = h('div', { cls: 'w98-win__statusbar' },
      h('div', { cls: 'w98-win__status-cell', css: { flex: '1' } }, title),
      h('div', { cls: 'w98-win__status-cell' }, '🌐 Internet zone')
    );

    const body = h('div', { css: { display: 'flex', flexDirection: 'column', flex: '1', overflow: 'hidden' } },
      menubar, addrBar, contentArea, statusbar
    );

    _openWin({ id, title, glyph, body, pos, history: [url], histIdx: 0 });

    // Fetch content immediately
    loadUrl(id, url, false);
  }

  /* ============================================================
     MY SHOP — tabbed collection browser window
     Reuses loadUrl()/wireContent() under the hood, so add-to-cart,
     product zoom, etc. all keep working inside every tab. Edit the
     tab list in CFG.shopTabs above — no other code changes needed.
     ============================================================ */
  function openMyShopWindow(initialTabIdx) {
    openTabbedWindow({
      id: 'win-store', title: 'My Shop', glyph: '🛍️',
      tabs: CFG.shopTabs, initialTabIdx: initialTabIdx,
    });
  }

  // Merch icon window — same tabbed browser as My Shop, with its own tab
  // list (CFG.merchTabs) so Merch can have its own categories.
  function openMerchWindow(initialTabIdx) {
    openTabbedWindow({
      id: 'win-merch', title: 'Merch', glyph: '🛍️',
      tabs: CFG.merchTabs, initialTabIdx: initialTabIdx,
    });
  }

  function openTabbedWindow(opts) {
    const id = opts.id;
    if (wins.has(id)) {
      const s = wins.get(id);
      if (s.minified) restoreWin(id); else bringToFront(s.el);
      return;
    }

    const pos = nextPos();
    const tabs = (opts.tabs && opts.tabs.length)
      ? opts.tabs
      : [{ label: 'Gwak Shop', url: '/collections/catalog' }];
    const initialTabIdx = opts.initialTabIdx;
    // Optional: open on a specific page (e.g. a product) while still
    // showing the tab strip, with the matching tab highlighted.
    const startUrl = (idx) => opts.initialUrl || tabs[idx].url;
    const startIdx = (typeof initialTabIdx === 'number' && tabs[initialTabIdx]) ? initialTabIdx : 0;

    injectShopTabStyles();

    const menubar = h('div', { cls: 'w98-win__menubar' },
      ...['File', 'Edit', 'View', 'Favorites', 'Tools', 'Help'].map(m => h('span', {}, m))
    );

    /* ── Tab strip ── */
    const tabBtns = [];
    const tabStrip = h('div', { cls: 'w98-shoptabs' });

    /* ── Scrollable content area ── */
    const contentArea = h('div', { cls: 'w98-win__content' });
    contentArea.appendChild(h('div', { cls: 'w98-win__loader' }, '⏳  Loading…'));

    const statusCell = h('div', { cls: 'w98-win__status-cell', css: { flex: '1' } }, tabs[startIdx].label);

    function selectTab(idx) {
      tabBtns.forEach((b, i) => b.classList.toggle('w98-shoptab--active', i === idx));
      statusCell.textContent = tabs[idx].label;
      loadUrl(id, tabs[idx].url, true);
    }

    const FALLBACK_TAB_COLORS = ['#000080', '#cc6600', '#008080', '#7b2fbf', '#a30000', '#1a7a1a', '#e25822', '#d6336c'];

    // After Back/Forward lands on a collection page, light up its tab again.
    function syncTabTo(url) {
      const idx = tabs.findIndex(t => t.url === url);
      if (idx === -1) return;
      tabBtns.forEach((b, i) => b.classList.toggle('w98-shoptab--active', i === idx));
      statusCell.textContent = tabs[idx].label;
    }

    // Back / Forward — same history as the page windows (loadUrl keeps
    // the buttons' enabled state in sync via the w98-win__back/__fwd classes).
    const backBtn = h('button', {
      cls: 'w98-win__addr-go w98-win__back', title: 'Back', type: 'button', disabled: '',
      css: { minWidth: '30px', alignSelf: 'center', marginRight: '2px' },
      '$click': () => {
        const st = wins.get(id);
        if (!st || st.histIdx <= 0) return;
        st.histIdx--;
        syncTabTo(st.history[st.histIdx]);
        loadUrl(id, st.history[st.histIdx], false);
      }
    }, '◀\uFE0E');
    const fwdBtn = h('button', {
      cls: 'w98-win__addr-go w98-win__fwd', title: 'Forward', type: 'button', disabled: '',
      css: { minWidth: '30px', alignSelf: 'center', marginRight: '6px' },
      '$click': () => {
        const st = wins.get(id);
        if (!st || st.histIdx >= st.history.length - 1) return;
        st.histIdx++;
        syncTabTo(st.history[st.histIdx]);
        loadUrl(id, st.history[st.histIdx], false);
      }
    }, '▶\uFE0E');
    tabStrip.appendChild(backBtn);
    tabStrip.appendChild(fwdBtn);

    tabs.forEach((tab, i) => {
      const accent = tab.color || FALLBACK_TAB_COLORS[i % FALLBACK_TAB_COLORS.length];
      const btn = h('button', {
        cls: 'w98-shoptab' + (i === startIdx ? ' w98-shoptab--active' : ''),
        type: 'button',
        css: { '--tab-accent': accent },
        '$click': () => selectTab(i),
      }, tab.icon ? (tab.icon + ' ' + tab.label) : tab.label);
      tabBtns.push(btn);
      tabStrip.appendChild(btn);
    });

    const statusbar = h('div', { cls: 'w98-win__statusbar' },
      statusCell,
      h('div', { cls: 'w98-win__status-cell' }, '🌐 Internet zone')
    );

    const body = h('div', { css: { display: 'flex', flexDirection: 'column', flex: '1', overflow: 'hidden' } },
      menubar, tabStrip, contentArea, statusbar
    );

    _openWin({ id, title: opts.title, glyph: opts.glyph, body, pos, history: [startUrl(startIdx)], histIdx: 0 });

    // Load the starting tab (or the requested page) immediately
    loadUrl(id, startUrl(startIdx), false);
  }

  function injectShopTabStyles() {
    if (document.getElementById('w98-shoptabs-css')) return;
    const css = `
      .w98-shoptabs {
        display: flex; flex-wrap: wrap; gap: 4px;
        padding: 6px 6px 0 6px; background: silver;
        border-bottom: 1px solid #808080;
      }
      .w98-shoptab {
        font-family: var(--w98-font, inherit); font-size: 11px; font-weight: 600;
        padding: 5px 12px 6px 12px; cursor: pointer;
        background: #fff; color: var(--tab-accent, #333);
        border: 1px solid #fff;
        border-top: 3px solid var(--tab-accent, #808080);
        border-right-color: #808080; border-bottom-color: #808080;
        border-radius: 2px 2px 0 0;
        transition: transform 0.08s ease, box-shadow 0.08s ease;
        box-shadow: 0 1px 2px rgba(0,0,0,0.15);
      }
      .w98-shoptab:hover {
        background: #fff;
        transform: translateY(-1px);
        box-shadow: 0 2px 4px rgba(0,0,0,0.25);
      }
      .w98-shoptab--active {
        background: var(--tab-accent, #000080);
        color: #fff;
        border-color: var(--tab-accent, #000080);
        border-top: 3px solid var(--tab-accent, #000080);
        box-shadow: 0 2px 5px rgba(0,0,0,0.35);
        transform: translateY(-1px);
      }
    `;
    const styleEl = document.createElement('style');
    styleEl.id = 'w98-shoptabs-css';
    styleEl.textContent = css;
    document.head.appendChild(styleEl);
  }

  /* ============================================================
     CORE WINDOW CREATOR (shared by page windows and dialogs)
     ============================================================ */
  function _openWin({ id, title, glyph, body, pos, history = [], histIdx = 0, w, h: wh, forceSize }) {
    const mob = isMobile() && !forceSize;
    const W = mob ? desktop.clientWidth  : (w  || CFG.defaultW);
    const H = mob ? desktop.clientHeight : (wh || CFG.defaultH);
    const x = mob ? 0 : pos.x;
    const y = mob ? 0 : pos.y;

    /* Title bar */
    const titleNode = h('div', { cls: 'w98-win__title' },
      h('span', { cls: 'w98-win__title-icon' }, glyph || '🪟'),
      h('span', {}, title || 'Window')
    );

    const minBtn   = h('button', { cls: 'w98-win__btn', title: 'Minimize', '$click': () => minimizeWin(id) }, '—');
    const maxBtn   = h('button', { cls: 'w98-win__btn', title: 'Maximize', '$click': () => toggleMax(id) },   '□');
    const closeBtn = h('button', { cls: 'w98-win__btn', title: 'Close',    '$click': () => closeWin(id) },    '✕');

    const titlebar = h('div', { cls: 'w98-win__titlebar' },
      titleNode,
      h('div', { cls: 'w98-win__controls' }, minBtn, maxBtn, closeBtn)
    );

    const winEl = h('div', {
      id,
      cls: 'w98-win',
      css: { left: x + 'px', top: y + 'px', width: W + 'px', height: H + 'px', zIndex: ++topZ },
      '$mousedown': () => bringToFront(winEl),
    }, titlebar, body);

    makeDraggable(winEl, titlebar);
    makeResizable(winEl);
    desktop.appendChild(winEl);

    wins.forEach(s => s.el.classList.add('w98-win--inactive'));

    /* Taskbar button */
    const tbBtn = h('button', {
      cls: 'w98-tb-btn w98-active',
      title,
      '$click': () => {
        const s = wins.get(id);
        if (!s) return;
        if (s.minified) { restoreWin(id); return; }
        if (!winEl.classList.contains('w98-win--inactive')) { minimizeWin(id); return; }
        bringToFront(winEl);
      }
    }, (glyph || '') + ' ' + (title || '').slice(0, 16));

    tbWindowsEl.appendChild(tbBtn);

    wins.set(id, {
      el: winEl, tbBtn,
      minified: false, maxed: false,
      restore: { x, y, w: W, h: H },
      history, histIdx,
    });
  }

  /* ============================================================
     WINDOW ACTIONS: minimize / restore / maximize / close
     ============================================================ */
  function minimizeWin(id) {
    const s = wins.get(id); if (!s) return;
    s.el.style.display = 'none';
    s.minified = true;
    s.tbBtn.classList.remove('w98-active');
  }

  function restoreWin(id) {
    const s = wins.get(id); if (!s) return;
    s.el.style.display = 'flex';
    s.minified = false;
    bringToFront(s.el);
  }

  function toggleMax(id) {
    const s = wins.get(id); if (!s) return;
    if (s.maxed) {
      Object.assign(s.el.style, {
        left: s.restore.x + 'px', top: s.restore.y + 'px',
        width: s.restore.w + 'px', height: s.restore.h + 'px',
      });
      s.el.classList.remove('w98-win--maximized');
      s.maxed = false;
    } else {
      s.restore = { x: s.el.offsetLeft, y: s.el.offsetTop, w: s.el.offsetWidth, h: s.el.offsetHeight };
      Object.assign(s.el.style, { left: '0', top: '0', width: '100%', height: '100%' });
      s.el.classList.add('w98-win--maximized');
      s.maxed = true;
    }
    bringToFront(s.el);
  }

  function closeWin(id) {
    const s = wins.get(id); if (!s) return;
    s.el.remove(); s.tbBtn.remove(); wins.delete(id);
    if (wins.size === 0) cascade = 0;
  }

  /* ============================================================
     DRAG & RESIZE
     ============================================================ */
  function makeDraggable(winEl, handle) {
    if (isMobile()) return; // windows are fixed full-screen on mobile

    let ox, oy, sl, st;

    function start(cx, cy) {
      ox = cx; oy = cy; sl = winEl.offsetLeft; st = winEl.offsetTop;
    }
    function move(cx, cy) {
      if (wins.get(winEl.id)?.maxed) return;
      const dW = desktop.clientWidth, dH = desktop.clientHeight;
      const wW = winEl.offsetWidth,   wH = winEl.offsetHeight;
      winEl.style.left = Math.min(dW - 40, Math.max(-(wW - 60), sl + cx - ox)) + 'px';
      winEl.style.top  = Math.min(dH - 26, Math.max(0, st + cy - oy)) + 'px';
    }

    handle.addEventListener('mousedown', e => {
      if (e.target.closest('.w98-win__btn')) return;
      e.preventDefault(); start(e.clientX, e.clientY);
      const mm = e2 => move(e2.clientX, e2.clientY);
      const mu = () => { document.removeEventListener('mousemove', mm); document.removeEventListener('mouseup', mu); };
      document.addEventListener('mousemove', mm); document.addEventListener('mouseup', mu);
    });

    handle.addEventListener('touchstart', e => {
      if (e.target.closest('.w98-win__btn')) return;
      const t = e.touches[0]; start(t.clientX, t.clientY);
      const tm = e2 => { const t2 = e2.touches[0]; move(t2.clientX, t2.clientY); };
      const tu = () => { handle.removeEventListener('touchmove', tm); handle.removeEventListener('touchend', tu); };
      handle.addEventListener('touchmove', tm, { passive: true }); handle.addEventListener('touchend', tu);
    }, { passive: true });
  }

  function makeResizable(winEl) {
    if (isMobile()) return; // no resize on mobile

    const grip = h('div', { cls: 'w98-win__resize' });
    winEl.appendChild(grip);
    let sx, sy, sw, sh;
    grip.addEventListener('mousedown', e => {
      e.stopPropagation(); e.preventDefault();
      sx = e.clientX; sy = e.clientY; sw = winEl.offsetWidth; sh = winEl.offsetHeight;
      const mm = e2 => {
        const nw = Math.max(260, sw + e2.clientX - sx);
        const nh = Math.max(160, sh + e2.clientY - sy);
        winEl.style.width = nw + 'px'; winEl.style.height = nh + 'px';
        const s = wins.get(winEl.id);
        if (s) { s.restore.w = nw; s.restore.h = nh; }
      };
      const mu = () => { document.removeEventListener('mousemove', mm); document.removeEventListener('mouseup', mu); };
      document.addEventListener('mousemove', mm); document.addEventListener('mouseup', mu);
    });
  }

  /* ============================================================
     BUILT-IN DIALOGS
     ============================================================ */
  function openAbout() {
    if (wins.has('w98-about')) { restoreWin('w98-about'); return; }
    const body = h('div', { css: { display: 'flex', flexDirection: 'column', flex: '1' } },
      h('div', { cls: 'w98-win__body' },
        h('div', { css: { display: 'flex', gap: '14px', alignItems: 'flex-start', marginBottom: '10px' } },
          h('span', { css: { fontSize: '46px', lineHeight: '1' } }, '🖼️'),
          h('div', {},
            h('p', { css: { fontWeight: '700', fontSize: '14px', margin: '0 0 3px' } }, CFG.storeName),
            h('p', { css: { margin: '0 0 3px' } }, 'Windows 98 Edition'),
            h('p', { css: { margin: '0', fontSize: '11px', color: '#555' } }, '© ' + new Date().getFullYear())
          )
        ),
        h('hr', { css: { borderColor: '#808080', margin: '6px 0' } }),
        h('p', { css: { margin: '0', fontSize: '11px' } },
          'Running Windows 98. Memory: 64 MB. System resources: 72% free.')
      ),
      h('div', { cls: 'w98-win__footer-btns' },
        h('button', { cls: 'w98-dialog-btn', '$click': () => closeWin('w98-about') }, 'OK')
      )
    );
    _openWin({ id: 'w98-about', title: 'About ' + CFG.storeName, glyph: 'ℹ️', body, pos: nextPos(), w: 340, h: 210 });
  }

  /* ── shared Explorer toolbar builder ── */
  function _explorerToolbar(pathLabel, onUp) {
    const bar = document.createElement('div');
    bar.style.cssText = `
      display:flex; align-items:center; gap:4px; padding:3px 6px;
      background:var(--w98-gray);
      border-bottom:1px solid var(--w98-btn-shadow);
      flex-shrink:0; font-family:var(--w98-font); font-size:12px;
    `;
    if (onUp) {
      const upBtn = document.createElement('button');
      upBtn.className = 'w98-dialog-btn';
      upBtn.textContent = '⬆ Up';
      upBtn.style.cssText = 'padding:1px 8px;font-size:11px;';
      upBtn.addEventListener('click', onUp);
      bar.appendChild(upBtn);
    }
    const addr = document.createElement('div');
    addr.style.cssText = `
      flex:1; padding:2px 6px; background:#fff;
      border-top:1px solid var(--w98-btn-dark); border-left:1px solid var(--w98-btn-dark);
      border-right:1px solid var(--w98-btn-hi); border-bottom:1px solid var(--w98-btn-hi);
      font-size:11px; white-space:nowrap; overflow:hidden; text-overflow:ellipsis;
    `;
    addr.textContent = pathLabel;
    bar.appendChild(addr);
    return bar;
  }

  /* ── shared Explorer status bar ── */
  function _explorerStatus(text) {
    const bar = document.createElement('div');
    bar.style.cssText = `
      padding:2px 8px; font-family:var(--w98-font); font-size:11px;
      background:var(--w98-gray); border-top:1px solid var(--w98-btn-shadow);
      flex-shrink:0; color:#000;
    `;
    bar.textContent = text;
    return bar;
  }

  /* ── shared file/folder icon grid ── */
  function _iconGrid(items) {
    const grid = document.createElement('div');
    grid.style.cssText = `
      display:flex; flex-wrap:wrap; gap:6px; padding:10px;
      align-content:flex-start;
    `;
    items.forEach(item => {
      const cell = document.createElement('div');
      cell.style.cssText = `
        display:flex; flex-direction:column; align-items:center;
        width:76px; padding:6px 4px; cursor:default;
        border:1px solid transparent; border-radius:2px;
        font-family:var(--w98-font); font-size:11px;
        text-align:center; word-break:break-all;
      `;
      cell.addEventListener('mouseenter', () => {
        cell.style.background = 'rgba(0,0,128,0.15)';
        cell.style.borderColor = 'rgba(0,0,128,0.3)';
      });
      cell.addEventListener('mouseleave', () => {
        cell.style.background = 'transparent';
        cell.style.borderColor = 'transparent';
      });

      const icon = document.createElement('div');
      icon.style.cssText = 'font-size:38px;line-height:1;margin-bottom:4px;';
      icon.textContent = item.glyph;

      const label = document.createElement('div');
      label.textContent = item.name;

      cell.appendChild(icon);
      cell.appendChild(label);
      if (isMobile()) {
        /* single tap opens on mobile */
        cell.addEventListener('click', item.onOpen);
      } else {
        /* desktop: single click selects, double-click opens */
        cell.addEventListener('dblclick', item.onOpen);
        cell.addEventListener('click', () => {
          grid.querySelectorAll('div[data-selected]').forEach(d => {
            d.removeAttribute('data-selected');
            d.style.background = 'transparent';
            d.style.borderColor = 'transparent';
          });
          cell.setAttribute('data-selected', '1');
          cell.style.background = 'rgba(0,0,128,0.25)';
          cell.style.borderColor = 'rgba(0,0,128,0.5)';
        });
      }

      grid.appendChild(cell);
    });
    return grid;
  }

  function openRecycleBin() {
    if (wins.has('w98-recycle')) { restoreWin('w98-recycle'); return; }

    const toolbar = _explorerToolbar('C:\\RECYCLED');

    const grid = _iconGrid([
      {
        glyph: '📁',
        name:  'Modeling',
        onOpen: openModelingPhotos,
      },
      {
        glyph: '📁',
        name:  'Nudes',
        onOpen: openGwakNudes,
      },
      {
        glyph: '📁',
        name:  'Heather',
        onOpen: openHeatherFolder,
      },
    ]);

    /* faint "deleted" watermark styling */
    grid.style.opacity = '0.92';

    const status = _explorerStatus('3 object(s)  |  Originally deleted 3/14/2024');

    const body = document.createElement('div');
    body.style.cssText = 'display:flex;flex-direction:column;flex:1;min-height:0;';

    /* Win98 Explorer left-panel + right-panel layout */
    const splitPane = document.createElement('div');
    splitPane.style.cssText = 'display:flex;flex:1;min-height:0;';

    /* left tree panel — hidden on mobile to save space */
    const leftPane = document.createElement('div');
    leftPane.style.cssText = `
      width:140px; flex-shrink:0; border-right:1px solid var(--w98-btn-shadow);
      background:var(--w98-gray); padding:6px 4px; font-family:var(--w98-font);
      font-size:11px; overflow-y:auto;
      ${isMobile() ? 'display:none;' : ''}
    `;
    leftPane.innerHTML = `
      <div style="display:flex;align-items:center;gap:4px;margin-bottom:4px;">
        <span style="font-size:16px;">🖥️</span>
        <span style="font-weight:700;">Desktop</span>
      </div>
      <div style="margin-left:16px;">
        <div style="display:flex;align-items:center;gap:4px;color:#000080;font-weight:700;">
          <span style="font-size:14px;">🗑️</span>
          <span>Recycle Bin</span>
        </div>
      </div>
    `;

    /* right content area — scrollable */
    const rightPane = document.createElement('div');
    rightPane.style.cssText = 'flex:1;overflow-y:auto;overflow-x:hidden;min-height:0;background:#fff;';
    rightPane.appendChild(grid);

    splitPane.appendChild(leftPane);
    splitPane.appendChild(rightPane);

    body.appendChild(toolbar);
    body.appendChild(splitPane);
    body.appendChild(status);

    _openWin({ id: 'w98-recycle', title: 'Recycle Bin', glyph: '🗑️', body, pos: nextPos(), w: 500, h: 340 });
  }

  function openModelingPhotos() {
    const WIN_ID = 'w98-modeling-photos';
    if (wins.has(WIN_ID)) { restoreWin(WIN_ID); return; }

    const photos = CFG.modelingPhotos;

    const toolbar = _explorerToolbar('C:\\RECYCLED\\GWAK Modeling Photos', () => {
      openRecycleBin(); closeWin(WIN_ID);
    });

    let items;
    if (photos && photos.length > 0) {
      items = photos.map((p, i) => ({
        glyph: '🖼️',
        name:  p.name || ('photo_' + (i + 1) + '.jpg'),
        onOpen: () => openPhotoViewer(p.name || ('Photo ' + (i + 1)), p.url),
      }));
    } else {
      /* placeholder files shown before real photos are added */
      items = [
        { glyph: '🖼️', name: 'DSC_0001.jpg',          onOpen: () => _noPhotoAlert() },
        { glyph: '🖼️', name: 'gwak_shoot_2023.jpg',   onOpen: () => _noPhotoAlert() },
        { glyph: '🖼️', name: 'backstage_001.png',     onOpen: () => _noPhotoAlert() },
        { glyph: '🖼️', name: 'portfolio_final.jpg',   onOpen: () => _noPhotoAlert() },
        { glyph: '🖼️', name: 'promo_shoot.jpg',       onOpen: () => _noPhotoAlert() },
      ];
    }

    function _noPhotoAlert() {
      alert('Add your photo URLs to CFG.modelingPhotos in windows95.js to display images here.');
    }

    const grid   = _iconGrid(items);
    const status = _explorerStatus(items.length + ' object(s)');

    const rightPane = document.createElement('div');
    rightPane.style.cssText = 'flex:1;overflow-y:auto;overflow-x:hidden;min-height:0;background:#fff;';
    rightPane.appendChild(grid);

    const splitPane = document.createElement('div');
    splitPane.style.cssText = 'display:flex;flex:1;min-height:0;';

    const leftPane = document.createElement('div');
    leftPane.style.cssText = `
      width:140px;flex-shrink:0;border-right:1px solid var(--w98-btn-shadow);
      background:var(--w98-gray);padding:6px 4px;font-family:var(--w98-font);
      font-size:11px;overflow-y:auto;
    `;
    leftPane.innerHTML = `
      <div style="display:flex;align-items:center;gap:4px;margin-bottom:4px;">
        <span style="font-size:16px;">🖥️</span><span style="font-weight:700;">Desktop</span>
      </div>
      <div style="margin-left:16px;">
        <div style="display:flex;align-items:center;gap:4px;">
          <span style="font-size:14px;">🗑️</span><span>Recycle Bin</span>
        </div>
        <div style="margin-left:16px;color:#000080;font-weight:700;">
          <span style="font-size:12px;">📁</span> Modeling Photos
        </div>
      </div>
    `;

    splitPane.appendChild(leftPane);
    splitPane.appendChild(rightPane);

    const body = document.createElement('div');
    body.style.cssText = 'display:flex;flex-direction:column;flex:1;min-height:0;';
    body.appendChild(toolbar);
    body.appendChild(splitPane);
    body.appendChild(status);

    _openWin({ id: WIN_ID, title: 'GWAK Modeling Photos', glyph: '📁', body, pos: nextPos(), w: 520, h: 360 });
  }

  function openPhotoViewer(name, url) {
    const WIN_ID = 'w98-photo-' + name.replace(/[^a-z0-9]/gi, '-');
    if (wins.has(WIN_ID)) { restoreWin(WIN_ID); return; }

    const body = document.createElement('div');
    body.style.cssText = 'display:flex;flex-direction:column;flex:1;min-height:0;background:#000;';

    /* toolbar */
    const tb = document.createElement('div');
    tb.style.cssText = `
      display:flex;align-items:center;gap:6px;padding:3px 6px;
      background:var(--w98-gray);border-bottom:1px solid var(--w98-btn-shadow);
      flex-shrink:0;font-family:var(--w98-font);font-size:11px;
    `;
    tb.innerHTML = `<span style="font-size:16px;">🖼️</span><span>${name}</span>`;

    /* image */
    const imgWrap = document.createElement('div');
    imgWrap.style.cssText = 'flex:1;overflow:auto;display:flex;align-items:flex-start;justify-content:center;min-height:0;background:#000;';

    const img = document.createElement('img');
    img.src = url;
    img.alt = name;
    img.style.cssText = 'width:100%;height:auto;display:block;';

    imgWrap.appendChild(img);
    body.appendChild(tb);
    body.appendChild(imgWrap);

    _openWin({ id: WIN_ID, title: name, glyph: '🖼️', body, pos: nextPos(), w: 620, h: 520 });
  }

  function openGwakNudes() {
    const WIN_ID = 'w98-gwak-nudes';
    if (wins.has(WIN_ID)) { restoreWin(WIN_ID); return; }

    // ── Play Rick Astley MP3 instantly on click (works on iPhone) ──
    try {
      var nudesAudio = new Audio('https://cdn.shopify.com/s/files/1/0687/7675/5418/files/Rick_Astley_-_Never_Gonna_Give_You_Up_Official_Video_4K_Remaster.mp3?v=1783604677');
      nudesAudio.volume = 1;
      nudesAudio.play().catch(function() {});
    } catch(e) {}

    const body = document.createElement('div');
    body.style.cssText = 'display:flex;flex-direction:column;align-items:center;justify-content:center;flex:1;min-height:0;background:#000;color:#fff;font-family:var(--w98-font);font-size:18px;gap:12px;';
    body.innerHTML = '<span style="font-size:48px;">🔒</span><span>Access Denied</span>';

    _openWin({ id: WIN_ID, title: 'GWAK Nudes', glyph: '📁', body, pos: nextPos(), w: 340, h: 220 });
  }

  /* ── Heather folder ── */
  function openHeatherFolder() {
    const WIN_ID = 'w98-heather-folder';
    if (wins.has(WIN_ID)) { restoreWin(WIN_ID); return; }

    const toolbar = _explorerToolbar('C:\\RECYCLED\\Heather', () => {
      openRecycleBin(); closeWin(WIN_ID);
    });

    const grid = _iconGrid([
      {
        glyph: '🎬',
        name:  'Heather.mov',
        onOpen: openHeatherPlayer,
      },
    ]);

    const status = _explorerStatus('1 object(s)  |  248 MB');

    const rightPane = document.createElement('div');
    rightPane.style.cssText = 'flex:1;overflow-y:auto;overflow-x:hidden;min-height:0;background:#fff;';
    rightPane.appendChild(grid);

    const leftPane = document.createElement('div');
    leftPane.style.cssText = `
      width:140px;flex-shrink:0;border-right:1px solid var(--w98-btn-shadow);
      background:var(--w98-gray);padding:6px 4px;font-family:var(--w98-font);
      font-size:11px;overflow-y:auto;
    `;
    leftPane.innerHTML = `
      <div style="display:flex;align-items:center;gap:4px;margin-bottom:4px;">
        <span style="font-size:16px;">🖥️</span><span style="font-weight:700;">Desktop</span>
      </div>
      <div style="margin-left:16px;">
        <div style="display:flex;align-items:center;gap:4px;">
          <span style="font-size:14px;">🗑️</span><span>Recycle Bin</span>
        </div>
        <div style="margin-left:16px;color:#000080;font-weight:700;">
          <span style="font-size:12px;">📁</span> Heather
        </div>
      </div>
    `;

    const splitPane = document.createElement('div');
    splitPane.style.cssText = 'display:flex;flex:1;min-height:0;';
    splitPane.appendChild(leftPane);
    splitPane.appendChild(rightPane);

    const body = document.createElement('div');
    body.style.cssText = 'display:flex;flex-direction:column;flex:1;min-height:0;';
    body.appendChild(toolbar);
    body.appendChild(splitPane);
    body.appendChild(status);

    _openWin({ id: WIN_ID, title: 'Heather', glyph: '📁', body, pos: nextPos(), w: 400, h: 260 });
  }

  /* ── Heather fake media player ── */
  function openHeatherPlayer() {
    const WIN_ID = 'w98-heather-player';
    if (wins.has(WIN_ID)) { restoreWin(WIN_ID); return; }

    const body = document.createElement('div');
    body.style.cssText = 'display:flex;flex-direction:column;flex:1;min-height:0;background:#000;';

    /* ── Win98 media player toolbar ── */
    const toolbar = document.createElement('div');
    toolbar.style.cssText = `
      background:#c0c0c0;border-bottom:1px solid #808080;
      padding:3px 6px;display:flex;align-items:center;gap:4px;flex-shrink:0;
      font-family:var(--w98-font);font-size:11px;
    `;
    toolbar.innerHTML = `
      <span style="font-size:14px;">🎬</span>
      <span>Windows Media Player</span>
      <span style="margin-left:auto;color:#808080;">Heather.mov  —  248 MB</span>
    `;

    /* ── Thumbnail + play button overlay ── */
    const stage = document.createElement('div');
    stage.style.cssText = `
      flex:1;position:relative;display:flex;align-items:center;
      justify-content:center;min-height:0;overflow:hidden;background:#000;cursor:pointer;
    `;

    /* thumbnail image */
    const thumb = document.createElement('div');
    thumb.style.cssText = 'position:absolute;inset:0;display:flex;align-items:center;justify-content:center;';

    if (CFG.heatherThumb) {
      const img = document.createElement('img');
      img.src = CFG.heatherThumb;
      img.style.cssText = 'width:100%;height:100%;object-fit:cover;display:block;';
      thumb.appendChild(img);
    } else {
      /* placeholder gradient until image is added */
      thumb.style.background = 'linear-gradient(135deg,#1a1a2e,#16213e,#0f3460)';
      const ph = document.createElement('div');
      ph.style.cssText = 'color:#ffffff44;font-family:var(--w98-font);font-size:12px;text-align:center;';
      ph.textContent = 'Add heatherThumb URL to CFG';
      thumb.appendChild(ph);
    }

    /* dark overlay so play button pops */
    const dimmer = document.createElement('div');
    dimmer.style.cssText = 'position:absolute;inset:0;background:rgba(0,0,0,0.35);';

    /* play button */
    const playBtn = document.createElement('div');
    playBtn.style.cssText = `
      position:relative;z-index:2;
      width:72px;height:72px;border-radius:50%;
      background:rgba(255,255,255,0.92);
      display:flex;align-items:center;justify-content:center;
      box-shadow:0 4px 24px rgba(0,0,0,0.7);
      cursor:pointer;transition:transform 0.1s,box-shadow 0.1s;
    `;
    playBtn.innerHTML = `<span style="font-size:32px;margin-left:6px;">▶</span>`;
    playBtn.addEventListener('mouseenter', () => {
      playBtn.style.transform = 'scale(1.1)';
      playBtn.style.boxShadow = '0 6px 32px rgba(0,0,0,0.9)';
    });
    playBtn.addEventListener('mouseleave', () => {
      playBtn.style.transform = 'scale(1)';
      playBtn.style.boxShadow = '0 4px 24px rgba(0,0,0,0.7)';
    });
    playBtn.addEventListener('click', startVirusWindows);

    stage.appendChild(thumb);
    stage.appendChild(dimmer);
    stage.appendChild(playBtn);

    /* ── Win98 media player controls bar ── */
    const controls = document.createElement('div');
    controls.style.cssText = `
      background:#c0c0c0;border-top:2px solid #ffffff;
      padding:4px 8px;display:flex;align-items:center;gap:4px;flex-shrink:0;
      font-family:var(--w98-font);font-size:18px;
    `;
    controls.innerHTML = `
      <button class="w98-dialog-btn" style="font-size:14px;padding:1px 8px;" title="Play">▶</button>
      <button class="w98-dialog-btn" style="font-size:14px;padding:1px 8px;" title="Pause">⏸</button>
      <button class="w98-dialog-btn" style="font-size:14px;padding:1px 8px;" title="Stop">⏹</button>
      <div style="flex:1;margin:0 8px;height:6px;background:#808080;border-top:1px solid #404040;border-left:1px solid #404040;border-right:1px solid #fff;border-bottom:1px solid #fff;position:relative;">
        <div style="width:0%;height:100%;background:#000080;"></div>
        <div style="position:absolute;left:0;top:-3px;width:10px;height:12px;background:#c0c0c0;border:1px solid #000;"></div>
      </div>
      <span style="font-size:11px;font-family:var(--w98-font);">0:00 / 0:00</span>
    `;

    /* wire all three control buttons to the virus cascade */
    controls.querySelectorAll('button').forEach(btn => {
      btn.addEventListener('click', startVirusWindows);
    });

    body.appendChild(toolbar);
    body.appendChild(stage);
    body.appendChild(controls);

    _openWin({ id: WIN_ID, title: 'Heather.mov — Windows Media Player', glyph: '🎬', body, pos: nextPos(), w: 520, h: 400 });
  }

  /* ── Windows 98 error sound player ── */
  function playWindowsBeep() {
    /* If the real chord.wav has been uploaded, use it */
    if (CFG.virusSoundUrl) {
      try {
        const audio = new Audio(CFG.virusSoundUrl);
        audio.volume = 1.0;
        audio.play().catch(() => {});
      } catch (e) {}
      return;
    }

    /* Fallback synthesis until the real file is added */
    try {
      const ctx = new (window.AudioContext || window.webkitAudioContext)();
      const t   = ctx.currentTime;
      const notes = [
        { freq: 440.00, vol: 0.22 },
        { freq: 554.37, vol: 0.18 },
        { freq: 659.25, vol: 0.16 },
        { freq: 880.00, vol: 0.10 },
      ];
      notes.forEach(({ freq, vol }) => {
        const osc  = ctx.createOscillator();
        const gain = ctx.createGain();
        osc.type = 'sine';
        osc.frequency.setValueAtTime(freq, t);
        gain.gain.setValueAtTime(vol, t);
        gain.gain.exponentialRampToValueAtTime(0.001, t + 1.1);
        osc.connect(gain);
        gain.connect(ctx.destination);
        osc.start(t);
        osc.stop(t + 1.15);
      });
      setTimeout(() => ctx.close(), 1500);
    } catch (e) {}
  }

  /* ── Virus window cascade ── */
  function startVirusWindows() {
    const MESSAGES = [
      { title: 'VIRUS DETECTED',         icon: '⚠️',  body: 'Critical virus detected!\nSystem files are being deleted.' },
      { title: 'ERROR',                   icon: '🚨',  body: 'Fatal error 0x0000007E\nYour computer will explode.' },
      { title: 'WARNING',                 icon: '💀',  body: 'You have been hacked.\nAll your files belong to us.' },
      { title: 'SYSTEM32 DELETED',        icon: '☠️',  body: 'Windows\\System32 has\nbeen successfully deleted.' },
      { title: 'CONGRATULATIONS!!!',      icon: '🎉',  body: "You're our 1,000,000th visitor!\nYou've won a FREE iPad!!!" },
      { title: 'CRITICAL ERROR',          icon: '🔥',  body: 'CPU temperature: 9000°C\nMelting in 3... 2... 1...' },
      { title: 'Microsoft Update',        icon: '🪟',  body: 'Installing updates: 0%\nPlease do not turn off.' },
      { title: 'Internet Explorer',       icon: '🌐',  body: 'Congratulations! You have\nbeen selected for a survey.' },
      { title: 'Security Alert',          icon: '🔐',  body: 'Your IP has been logged.\nContact support immediately.' },
      { title: 'Drive Format Complete',   icon: '💾',  body: 'C:\\ has been formatted.\n4096 files deleted.' },
      { title: 'BSOD Incoming',           icon: '🖥️',  body: 'IRQL_NOT_LESS_OR_EQUAL\nPress OK to continue dying.' },
      { title: 'Download Complete',       icon: '📥',  body: 'virus.exe download complete.\nDouble-click to install!' },
    ];

    let count   = 0;
    const MAX   = 28;   /* cap so the browser doesn't actually die */
    let interval;

    function spawnOne() {
      if (count >= MAX) { clearInterval(interval); return; }
      const msg  = MESSAGES[count % MESSAGES.length];
      const id   = 'w98-virus-' + count;
      count++;

      /* random position across the whole viewport */
      const vw = window.innerWidth,  vh = window.innerHeight;
      const wx = Math.random() * Math.max(1, vw - 240);
      const wy = Math.random() * Math.max(1, vh - 160);

      const inner = document.createElement('div');
      inner.style.cssText = 'display:flex;flex-direction:column;flex:1;min-height:0;';

      /* body */
      const bdy = document.createElement('div');
      bdy.style.cssText = `
        display:flex;align-items:flex-start;gap:12px;padding:14px 16px;flex:1;
        font-family:var(--w98-font);font-size:12px;background:var(--w98-gray);
      `;
      const ico = document.createElement('span');
      ico.style.cssText = 'font-size:32px;flex-shrink:0;';
      ico.textContent = msg.icon;
      const txt = document.createElement('span');
      txt.style.cssText = 'white-space:pre-line;line-height:1.5;';
      txt.textContent = msg.body;
      bdy.appendChild(ico);
      bdy.appendChild(txt);

      /* ok button */
      const foot = document.createElement('div');
      foot.style.cssText = 'display:flex;justify-content:center;padding:6px;background:var(--w98-gray);border-top:1px solid var(--w98-btn-shadow);flex-shrink:0;';
      const okBtn = document.createElement('button');
      okBtn.className = 'w98-dialog-btn';
      okBtn.textContent = 'OK';
      okBtn.style.cssText = 'min-width:60px;';
      okBtn.addEventListener('click', () => {
        closeWin(id);
        /* closing one spawns two more (up to the cap) */
        if (count < MAX) { spawnOne(); spawnOne(); }
      });
      foot.appendChild(okBtn);

      inner.appendChild(bdy);
      inner.appendChild(foot);

      playWindowsBeep();

      const mob  = isMobile();
      const popW = mob ? Math.round(vw * 0.42) : 240;
      const popH = mob ? Math.round(vh * 0.18) : 150;
      const safeX = Math.random() * Math.max(1, vw - popW - 8);
      const safeY = Math.random() * Math.max(1, vh - popH - 52);

      _openWin({
        id,
        title: msg.title,
        glyph: msg.icon,
        body:  inner,
        pos:   { x: safeX, y: safeY },
        w:     popW,
        h:     popH,
        forceSize: true,
      });

      /* On mobile, add the popup class + CSS variables so the !important
         mobile rules are overridden by the .w98-win--popup selector */
      if (mob) {
        const winEl = document.getElementById(id);
        if (winEl) {
          winEl.classList.add('w98-win--popup');
          winEl.style.setProperty('--popup-x', safeX + 'px');
          winEl.style.setProperty('--popup-y', safeY + 'px');
          winEl.style.setProperty('--popup-w', popW + 'px');
          winEl.style.setProperty('--popup-h', popH + 'px');
        }
      }
    }

    /* spawn first wave rapidly */
    spawnOne();
    interval = setInterval(spawnOne, 280);
  }

  function openCommissions() {
    const WIN_ID = 'w98-commissions';
    if (wins.has(WIN_ID)) { restoreWin(WIN_ID); return; }

    /* ── helper: labelled field row ── */
    function field(labelText, inputEl) {
      const row = document.createElement('div');
      row.style.cssText = 'display:flex;flex-direction:column;gap:3px;margin-bottom:10px;';
      const lbl = document.createElement('label');
      lbl.textContent = labelText;
      lbl.style.cssText = 'font-family:var(--w98-font);font-size:12px;font-weight:700;color:#000;';
      row.appendChild(lbl);
      row.appendChild(inputEl);
      return row;
    }

    function input(type, name, placeholder) {
      const el = document.createElement('input');
      el.type = type; el.name = name;
      el.placeholder = placeholder || '';
      el.style.cssText = `
        width:100%;box-sizing:border-box;
        font-family:var(--w98-font);font-size:12px;
        padding:4px 5px;
        border-top:2px solid var(--w98-btn-dark);
        border-left:2px solid var(--w98-btn-dark);
        border-right:2px solid var(--w98-btn-hi);
        border-bottom:2px solid var(--w98-btn-hi);
        background:#fff;color:#000;
      `;
      return el;
    }

    function select(name, options) {
      const el = document.createElement('select');
      el.name = name;
      el.style.cssText = `
        width:100%;box-sizing:border-box;
        font-family:var(--w98-font);font-size:12px;
        padding:4px 5px;
        border-top:2px solid var(--w98-btn-dark);
        border-left:2px solid var(--w98-btn-dark);
        border-right:2px solid var(--w98-btn-hi);
        border-bottom:2px solid var(--w98-btn-hi);
        background:#fff;color:#000;
      `;
      options.forEach(([val, txt]) => {
        const opt = document.createElement('option');
        opt.value = val; opt.textContent = txt;
        el.appendChild(opt);
      });
      return el;
    }

    function textarea(name, placeholder, rows) {
      const el = document.createElement('textarea');
      el.name = name; el.placeholder = placeholder || '';
      el.rows = rows || 4;
      el.style.cssText = `
        width:100%;box-sizing:border-box;resize:vertical;
        font-family:var(--w98-font);font-size:12px;
        padding:4px 5px;
        border-top:2px solid var(--w98-btn-dark);
        border-left:2px solid var(--w98-btn-dark);
        border-right:2px solid var(--w98-btn-hi);
        border-bottom:2px solid var(--w98-btn-hi);
        background:#fff;color:#000;
      `;
      return el;
    }

    /* ── build form fields ── */
    const nameEl    = input('text',  'contact[name]',  'Your full name');
    const emailEl   = input('email', 'contact[email]', 'your@email.com');
    const phoneEl   = input('tel',   'contact[phone]', 'Optional phone number');
    const typeEl    = select('contact[type]', [
      ['',            '— Select one —'],
      ['commission',  'Commission'],
      ['collab',      'Collab'],
      ['both',        'Both'],
    ]);
    const budgetEl  = select('contact[budget]', [
      ['',              '— Select a budget range —'],
      ['$1–$1,000',     '$1 – $1,000'],
      ['$1,000–$5,000', '$1,000 – $5,000'],
      ['$5,000–$10,000','$5,000 – $10,000'],
      ['$10,000–$15,000','$10,000 – $15,000'],
      ['$15,000–$20,000','$15,000 – $20,000'],
      ['$20,000+',      '$20,000+'],
    ]);
    const sizeEl    = input('text',  'contact[size]',  'e.g. 8×10 in, A4, 24×36 in');
    const detailsEl = textarea('contact[body]',
      'Describe what you have in mind — subject, mood, colors, references, any special requests…', 5);

    const statusEl = document.createElement('p');
    statusEl.style.cssText = 'font-family:var(--w98-font);font-size:12px;margin:6px 0 0;color:#000;min-height:16px;';

    const submitBtn = document.createElement('button');
    submitBtn.textContent = 'Submit Commission Request';
    submitBtn.className = 'w98-dialog-btn';
    submitBtn.style.cssText = 'margin-top:8px;';

    const form = document.createElement('form');
    form.style.cssText = 'display:flex;flex-direction:column;';

    /* hidden fields Shopify contact form needs */
    ['form_type', 'utf8'].forEach((n, i) => {
      const hid = document.createElement('input');
      hid.type = 'hidden'; hid.name = n;
      hid.value = i === 0 ? 'contact' : '✓';
      form.appendChild(hid);
    });

    form.appendChild(field('Full Name *', nameEl));
    form.appendChild(field('Email Address *', emailEl));
    form.appendChild(field('Phone Number', phoneEl));
    form.appendChild(field('Commission / Collab Type *', typeEl));
    form.appendChild(field('Budget', budgetEl));
    form.appendChild(field('Desired Size / Dimensions', sizeEl));
    form.appendChild(field('Tell me about your commission *', detailsEl));
    form.appendChild(submitBtn);
    form.appendChild(statusEl);

    submitBtn.addEventListener('click', async (e) => {
      e.preventDefault();

      /* basic validation */
      if (!nameEl.value.trim())  { statusEl.textContent = '⚠ Please enter your name.';           nameEl.focus();    return; }
      if (!emailEl.value.trim()) { statusEl.textContent = '⚠ Please enter your email address.';  emailEl.focus();   return; }
      if (!typeEl.value)         { statusEl.textContent = '⚠ Please select a commission type.';  typeEl.focus();    return; }
      if (!detailsEl.value.trim()){ statusEl.textContent = '⚠ Please describe your commission.'; detailsEl.focus(); return; }

      submitBtn.disabled = true;
      statusEl.textContent = '⏳  Sending…';

      try {
        const payload = {
          name:    nameEl.value.trim(),
          email:   emailEl.value.trim(),
          phone:   phoneEl.value.trim() || '(not provided)',
          type:    typeEl.options[typeEl.selectedIndex].text,
          budget:  budgetEl.value || '(not specified)',
          size:    sizeEl.value.trim() || '(not specified)',
          message: detailsEl.value.trim(),
          _subject: `[Commission Request] ${typeEl.options[typeEl.selectedIndex].text} — ${nameEl.value.trim()}`,
        };

        const resp = await fetch('https://formspree.io/f/xredljav', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json',
                     'Accept': 'application/json' },
          body: JSON.stringify(payload),
        });

        if (resp.ok) {
          /* swap form for a success message */
          const wrap = form.parentElement;
          wrap.innerHTML = '';
          const msg = document.createElement('div');
          msg.style.cssText = 'display:flex;flex-direction:column;align-items:center;justify-content:center;gap:12px;padding:24px;text-align:center;flex:1;';
          msg.innerHTML = `
            <span style="font-size:48px">🎨</span>
            <p style="font-family:var(--w98-font);font-size:13px;font-weight:700;margin:0;">Commission Request Sent!</p>
            <p style="font-family:var(--w98-font);font-size:12px;margin:0;color:#333;">
              Thanks, ${nameEl.value.trim()}! I'll review your request and get back to you at<br>
              <strong>${emailEl.value.trim()}</strong> within 2–3 business days.
            </p>
          `;
          const closeBtn = document.createElement('button');
          closeBtn.className = 'w98-dialog-btn';
          closeBtn.textContent = 'Close Window';
          closeBtn.addEventListener('click', () => closeWin(WIN_ID));
          msg.appendChild(closeBtn);
          wrap.appendChild(msg);
        } else {
          statusEl.textContent = '⚠ Something went wrong. Please try again or email us directly.';
          submitBtn.disabled = false;
        }
      } catch {
        statusEl.textContent = '⚠ Network error. Please check your connection and try again.';
        submitBtn.disabled = false;
      }
    });

    /* ── header banner ── */
    const header = document.createElement('div');
    header.style.cssText = `
      background: linear-gradient(135deg, var(--w98-navy) 0%, #1a3a6b 100%);
      padding: 12px 14px;
      display: flex; align-items: center; gap: 10px;
    `;
    header.innerHTML = `
      <span style="font-size:28px">🎨</span>
      <div>
        <p style="margin:0;font-family:var(--w98-font);font-size:13px;font-weight:700;color:#fff;">Commissions / Collab Request</p>
        <p style="margin:0;font-family:var(--w98-font);font-size:11px;color:#aac4f0;">Fill out the form below and I'll be in touch!</p>
      </div>
    `;

    const scrollArea = document.createElement('div');
    scrollArea.style.cssText = 'flex:1;overflow-y:auto;overflow-x:hidden;padding:12px 14px;background:var(--w98-gray);min-height:0;';
    scrollArea.appendChild(form);

    const body = document.createElement('div');
    body.style.cssText = 'display:flex;flex-direction:column;flex:1;min-height:0;';
    body.appendChild(header);
    body.appendChild(scrollArea);

    _openWin({ id: WIN_ID, title: 'Commissions / Collab', glyph: '🎨', body, pos: nextPos(), w: 420, h: 540 });
  }

  /* ── Egg Game ── */
  /* ============================================================
     GWAK WORD
     Desktop : hidden off-screen iframe — audio only, no popup
     Mobile  : Win98 popup window with YouTube starting at t=9
     ============================================================ */
  function openGwakWord() {

    // ── MP3 route — works on all devices including iPhone ────────
    if (CFG.gwakSoundUrl) {
      try {
        var a = new Audio(CFG.gwakSoundUrl);
        a.volume = 1;
        a.play().catch(function() {});
      } catch(e) {}
      return;
    }

    // ── MOBILE fallback: Win98 popup with YouTube embed ──────────
    if (isMobile()) {
      var WIN_ID = 'w98-gwak-sound';
      if (wins.has(WIN_ID)) { restoreWin(WIN_ID); return; }

      var mBody = document.createElement('div');
      mBody.style.cssText = 'background:#000;display:flex;flex:1;min-height:0;';

      var mFrame = document.createElement('iframe');
      mFrame.setAttribute('src',
        'https://www.youtube.com/embed/dZUwIpWCRPI' +
        '?start=9&autoplay=1&controls=1&rel=0&playsinline=1&modestbranding=1'
      );
      mFrame.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture');
      mFrame.setAttribute('allowfullscreen', '');
      mFrame.style.cssText = 'width:100%;height:100%;border:none;display:block;';
      mBody.appendChild(mFrame);

      _openWin({
        id:    WIN_ID,
        title: '⚠️  DO NOT CLICK',
        glyph: '⚠️',
        body:  mBody,
        pos:   nextPos(),
        w:     300,
        h:     200,
      });
      return;
    }

    // ── DESKTOP fallback: hidden off-screen YouTube iframe ───────
    var prev = document.getElementById('gwak-yt-audio');
    if (prev) prev.remove();

    var wrap = document.createElement('div');
    wrap.id = 'gwak-yt-audio';
    wrap.style.cssText = 'position:fixed;left:-9999px;top:-9999px;width:2px;height:2px;overflow:hidden;pointer-events:none;z-index:-9999;';

    var dframe = document.createElement('iframe');
    dframe.src = 'https://www.youtube.com/embed/dZUwIpWCRPI' +
                '?start=9&autoplay=1&controls=0&rel=0' +
                '&playsinline=1&modestbranding=1&disablekb=1&mute=0';
    dframe.allow = 'autoplay; encrypted-media';
    dframe.style.cssText = 'width:2px;height:2px;border:none;display:block;';
    wrap.appendChild(dframe);
    document.body.appendChild(wrap);

    setTimeout(function() { wrap.remove(); }, 90000);
  }

  function openEggGame() {
    const WIN_ID = 'w98-egg-game';
    if (wins.has(WIN_ID)) { restoreWin(WIN_ID); return; }

    const body = document.createElement('div');
    body.style.cssText = 'display:flex;flex-direction:column;flex:1;min-height:0;background:#000;';

    const iframe = document.createElement('iframe');
    iframe.src = 'https://egggame.org';
    iframe.style.cssText = 'flex:1;width:100%;border:none;display:block;';
    iframe.setAttribute('allowfullscreen', '');
    iframe.setAttribute('allow', 'autoplay; fullscreen');

    /* fallback shown if the site blocks embedding */
    iframe.addEventListener('error', () => {
      body.innerHTML = `
        <div style="display:flex;flex-direction:column;align-items:center;justify-content:center;
                    flex:1;background:#000;color:#fff;font-family:var(--w98-font);text-align:center;gap:12px;padding:24px;">
          <div style="font-size:48px;">🥚</div>
          <div style="font-size:14px;font-weight:bold;">Egg Game</div>
          <div style="font-size:11px;color:#aaa;max-width:260px;line-height:1.5;">
            This site can't be embedded directly.<br>Click below to open it in a new tab.
          </div>
          <a href="https://egggame.org" target="_blank"
             style="padding:6px 18px;background:#c0c0c0;color:#000;text-decoration:none;
                    font-family:var(--w98-font);font-size:12px;
                    border-top:2px solid #fff;border-left:2px solid #fff;
                    border-right:2px solid #404040;border-bottom:2px solid #404040;">
            Open Egg Game ↗
          </a>
        </div>`;
    });

    body.appendChild(iframe);

    _openWin({
      id:    WIN_ID,
      title: 'Egg Game',
      glyph: '🥚',
      body,
      pos:   nextPos(),
      w:     640,
      h:     520,
    });
  }

  /* music player removed — will be rebuilt later */


  /* ============================================================
     YOUTUBE IFRAME API LOADER
     Loaded once and shared by the video window. Using the real
     API (rather than a plain <iframe src="...">) lets us detect
     onError events when a specific video can't be embedded, so
     we can show our OWN consistent fallback UI instead of relying
     on YouTube's own error rendering — which looks and behaves
     differently across desktop and mobile.
     ============================================================ */
  let _ytApiPromise = null;
  function loadYouTubeIframeAPI() {
    if (_ytApiPromise) return _ytApiPromise;
    _ytApiPromise = new Promise((resolve) => {
      if (window.YT && window.YT.Player) { resolve(window.YT); return; }
      const prevCallback = window.onYouTubeIframeAPIReady;
      window.onYouTubeIframeAPIReady = function () {
        if (typeof prevCallback === 'function') prevCallback();
        resolve(window.YT);
      };
      if (!document.getElementById('yt-iframe-api-script')) {
        const tag = document.createElement('script');
        tag.id = 'yt-iframe-api-script';
        tag.src = 'https://www.youtube.com/iframe_api';
        document.head.appendChild(tag);
      }
    });
    return _ytApiPromise;
  }

  /* Built once per open, shown only if the current video errors out */
  function buildYoutubeFallback(channelUrl) {
    const wrap = document.createElement('div');
    wrap.style.cssText = `
      flex:1; width:100%; display:flex; flex-direction:column;
      align-items:center; justify-content:center; gap:12px;
      background:#000; color:#fff; text-align:center; padding:24px;
      font-family: Arial, sans-serif; box-sizing:border-box;
    `;
    wrap.innerHTML = `
      <div style="font-size:38px;">▶</div>
      <div style="font-size:14px;font-weight:bold;">This video can't be played here</div>
      <div style="font-size:12px;color:#ccc;max-width:280px;line-height:1.5;">
        The creator has restricted embedding for this video. You can still watch it directly on YouTube.
      </div>
    `;
    const btn = document.createElement('a');
    btn.href = channelUrl;
    btn.target = '_blank';
    btn.textContent = '▶ Watch on YouTube';
    btn.style.cssText = `
      margin-top:4px; padding:8px 18px; background:#cc0000; color:#fff;
      text-decoration:none; border-radius:4px; font-size:12px; font-weight:bold;
    `;
    wrap.appendChild(btn);
    return wrap;
  }

  function openYouTube() {
    const WIN_ID = 'w98-youtube';
    if (wins.has(WIN_ID)) { restoreWin(WIN_ID); return; }

    const CHANNEL_ID   = 'UCZXzueSPL93Sm0Jh5vtjYLQ';
    const CHANNEL_NAME = 'GWAK Productions';
    const CHANNEL_URL  = 'https://www.youtube.com/@Gwakproductions';

    // Featured video shown when this icon is opened, embedded directly
    // (not via the "Uploads" playlist) — this sidesteps a known YouTube
    // quirk where Shorts can fail to embed through a playlist even when
    // embedding is allowed on the video itself.
    //
    // To swap in a different video later: grab the ID from its URL (the
    // part after "v="), and the start time in seconds from any "&t=43s"
    // in that URL (or set to 0 to start at the beginning).
    const FEATURED_VIDEO_ID    = 'dyvgo2wE4Dw';
    const FEATURED_VIDEO_START = 0;
    const FEATURED_VIDEO_URL   = `https://www.youtube.com/watch?v=${FEATURED_VIDEO_ID}`;

    /* ── top bar: old YouTube 2012 logo + channel info ── */
    const topBar = document.createElement('div');
    topBar.style.cssText = `
      display:flex; align-items:center; justify-content:space-between;
      padding:6px 10px;
      background:#fff;
      border-bottom:2px solid #cc0000;
      flex-shrink:0;
    `;

    /* classic 2012 YouTube wordmark */
    topBar.innerHTML = `
      <div style="display:flex;align-items:center;gap:10px;">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120 26" width="90" height="20">
          <!-- "You" on dark bg -->
          <rect x="0" y="0" width="52" height="26" rx="3" fill="#333"/>
          <text x="6" y="19" font-family="Arial Black,Arial,sans-serif" font-weight="900"
                font-size="14" fill="#fff">You</text>
          <!-- "Tube" on red -->
          <rect x="52" y="0" width="68" height="26" rx="3" fill="#cc0000"/>
          <text x="57" y="19" font-family="Arial Black,Arial,sans-serif" font-weight="900"
                font-size="14" fill="#fff">Tube</text>
        </svg>
        <span style="font-family:Arial,sans-serif;font-size:11px;color:#666;border-left:1px solid #ccc;padding-left:8px;">
          ${CHANNEL_NAME}
        </span>
      </div>
      <div style="display:flex;gap:6px;align-items:center;">
        <a href="${FEATURED_VIDEO_URL}" target="_blank"
           style="font-family:Arial,sans-serif;font-size:11px;color:#cc0000;text-decoration:none;
                  border:1px solid #cc0000;padding:3px 8px;border-radius:2px;white-space:nowrap;">
          ▶ Open on YouTube
        </a>
      </div>
    `;

    /* ── channel banner strip ── */
    const banner = document.createElement('div');
    banner.style.cssText = `
      background: linear-gradient(135deg, #1a1a1a 0%, #cc0000 60%, #ff4444 100%);
      height:54px; flex-shrink:0;
      display:flex; align-items:center; padding:0 14px; gap:12px;
    `;
    banner.innerHTML = `
      <div style="
        width:42px;height:42px;border-radius:50%;
        background:#cc0000;border:2px solid #fff;
        display:flex;align-items:center;justify-content:center;
        font-family:Arial Black,sans-serif;font-size:16px;font-weight:900;color:#fff;
        flex-shrink:0;
      ">G</div>
      <div>
        <p style="margin:0;font-family:Arial Black,sans-serif;font-size:14px;
                  font-weight:900;color:#fff;text-shadow:0 1px 3px rgba(0,0,0,0.5);">
          ${CHANNEL_NAME}
        </p>
        <p style="margin:0;font-family:Arial,sans-serif;font-size:11px;color:rgba(255,255,255,0.8);">
          @Gwakproductions
        </p>
      </div>
    `;

    /* ── embedded YouTube playlist (real player, so we can catch errors) ── */
    const playerId = 'yt-player-' + Date.now();
    const playerMount = document.createElement('div');
    playerMount.id = playerId;
    playerMount.style.cssText = 'width:100%;height:100%;';

    const fallback = buildYoutubeFallback(FEATURED_VIDEO_URL);
    fallback.style.display = 'none';

    const playerWrap = document.createElement('div');
    playerWrap.style.cssText = 'position:relative;flex:1;min-height:0;display:flex;background:#000;';
    playerWrap.appendChild(playerMount);
    playerWrap.appendChild(fallback);

    /* ── footer ── */
    const footer = document.createElement('div');
    footer.style.cssText = `
      background:#f8f8f8;border-top:1px solid #ccc;
      padding:4px 10px;flex-shrink:0;
      display:flex;align-items:center;justify-content:space-between;
    `;
    footer.innerHTML = `
      <span style="font-family:Arial,sans-serif;font-size:10px;color:#888;">
        Viewing in YouTube embedded player · Some features require opening on YouTube
      </span>
      <a href="${CHANNEL_URL}" target="_blank"
         style="font-family:Arial,sans-serif;font-size:10px;color:#cc0000;text-decoration:none;">
        Full channel ↗
      </a>
    `;

    /* ── assemble ── */
    const body = document.createElement('div');
    body.style.cssText = 'display:flex;flex-direction:column;flex:1;min-height:0;overflow:hidden;background:#000;';
    body.appendChild(topBar);
    body.appendChild(banner);
    body.appendChild(playerWrap);
    body.appendChild(footer);

    _openWin({ id: WIN_ID, title: 'YouTube — ' + CHANNEL_NAME, glyph: '▶', body, pos: nextPos(), w: 760, h: 520 });

    // Same settings on every device — no more mobile-only autoplay
    // causing desktop and mobile to hit different failure states.
    loadYouTubeIframeAPI().then(YT => {
      // The window may have been closed before the API finished loading
      if (!wins.has(WIN_ID)) return;
      new YT.Player(playerId, {
        videoId: FEATURED_VIDEO_ID,
        playerVars: {
          start: FEATURED_VIDEO_START,
          rel: 0,
          modestbranding: 1,
          autoplay: 0,
        },
        events: {
          onError: () => {
            playerMount.style.display = 'none';
            fallback.style.display = 'flex';
          },
        },
      });
    });
  }

  function openCartConfirm(fromWinId, productTitle) {
    const id = 'w98-cart-confirm';
    if (wins.has(id)) closeWin(id);

    const body = h('div', { css: { display: 'flex', flexDirection: 'column', flex: '1' } },
      h('div', { cls: 'w98-win__body' },
        h('div', { css: { display: 'flex', gap: '14px', alignItems: 'center' } },
          h('span', { css: { fontSize: '40px' } }, '🛒'),
          h('div', {},
            h('p', { css: { fontWeight: '700', margin: '0 0 4px' } }, 'Item Added!'),
            h('p', { css: { margin: '0', fontSize: '12px' } }, productTitle + ' was added to your cart.')
          )
        )
      ),
      h('div', { cls: 'w98-win__footer-btns' },
        h('button', {
          cls: 'w98-dialog-btn',
          '$click': () => { closeWin(id); openPageWin('win-cart', 'Cart', '🛒', '/cart'); }
        }, 'View Cart'),
        h('button', { cls: 'w98-dialog-btn', '$click': () => closeWin(id) }, 'Continue Shopping')
      )
    );

    const x = Math.max(0, window.innerWidth - 380);
    _openWin({ id, title: 'Shopping Cart', glyph: '🛒', body, pos: { x, y: 20 }, w: 340, h: 185 });
    setTimeout(() => { if (wins.has(id)) closeWin(id); }, 5000);
  }

  function showMsg(msg) {
    const id = 'w98-msg-' + Date.now();
    const body = h('div', { css: { display: 'flex', flexDirection: 'column', flex: '1' } },
      h('div', { cls: 'w98-win__body' }, h('p', {}, msg)),
      h('div', { cls: 'w98-win__footer-btns' },
        h('button', { cls: 'w98-dialog-btn', '$click': () => closeWin(id) }, 'OK')
      )
    );
    _openWin({ id, title: 'Windows 98', glyph: '⚠️', body, pos: nextPos(), w: 280, h: 140 });
  }

  /* ============================================================
     DESKTOP ICONS — draggable, positions saved to localStorage
     ============================================================ */
  function buildIcons() {
    const mob  = isMobile();
    const saved = JSON.parse(localStorage.getItem('w98-icon-pos') || '{}');
    /* Clear any previously saved position for the recycle bin so it
       always snaps to the bottom-right corner by default */
    delete saved['recycle'];

    /* On mobile, icons live in a scrollable flex-wrap container */
    let iconParent = desktop;
    if (mob) {
      const grid = document.createElement('div');
      grid.id = 'w98-mobile-icons';
      desktop.appendChild(grid);
      iconParent = grid;
    }

    CFG.icons.forEach((def, i) => {
      /* ── Glyph ── */
      let glyphEl;
      if (def.svg) {
        glyphEl = document.createElement('div');
        glyphEl.className = 'w98-icon__glyph w98-icon__glyph--svg';
        glyphEl.innerHTML = def.svg;
      } else {
        glyphEl = h('span', { cls: 'w98-icon__glyph' }, def.glyph || '📄');
      }

      /* ── Label (multi-line via \n) ── */
      const labelEl = document.createElement('span');
      labelEl.className = 'w98-icon__label';
      (def.label || '').split('\n').forEach((part, j) => {
        if (j > 0) labelEl.appendChild(document.createElement('br'));
        labelEl.appendChild(document.createTextNode(part));
      });

      /* ── Icon element ── */
      const icon = h('div', {
        cls: 'w98-icon' +
          (def.action === 'recycleBin' ? ' w98-icon--recycle' : '') +
          (def.highlight ? ' w98-icon--highlight' : ''),
        title: (def.label || '').replace(/\n/g, ' '),
        tabindex: '0',
      }, glyphEl, labelEl);

      /* ── Attention badge (e.g. "NEW") ── */
      if (def.badge) {
        const badgeEl = document.createElement('span');
        badgeEl.className = 'w98-icon__badge';
        badgeEl.textContent = def.badge;
        icon.appendChild(badgeEl);
      }

      if (mob) {
        /* Mobile: flow layout — CSS handles sizing via #w98-mobile-icons rules */
        icon.addEventListener('click', () => {
          document.querySelectorAll('.w98-icon').forEach(ic => ic.classList.remove('selected'));
          icon.classList.add('selected');
          handleIcon(def);
        });
      } else {
        /* Desktop: absolutely positioned, draggable ── */
        const defaultPos = def.defaultPos
          ? def.defaultPos(desktop)
          : { x: 8, y: 8 + i * 90 };
        const pos = saved[def.id] || defaultPos;
        icon.style.position = 'absolute';
        icon.style.left     = pos.x + 'px';
        icon.style.top      = pos.y + 'px';

        let didDrag = false;

        icon.addEventListener('mousedown', e => {
          if (e.button !== 0) return;
          e.preventDefault();

          const ox = e.clientX, oy = e.clientY;
          const sl = icon.offsetLeft, st = icon.offsetTop;
          didDrag = false;
          icon.style.zIndex = '9999';

          const move = ev => {
            const dx = ev.clientX - ox, dy = ev.clientY - oy;
            if (!didDrag && Math.abs(dx) < 5 && Math.abs(dy) < 5) return;
            didDrag = true;
            const dW = desktop.clientWidth, dH = desktop.clientHeight;
            icon.style.left = Math.max(0, Math.min(dW - 76, sl + dx)) + 'px';
            icon.style.top  = Math.max(0, Math.min(dH - 90, st + dy)) + 'px';
          };

          const up = () => {
            icon.style.zIndex = '';
            if (didDrag) {
              const p = JSON.parse(localStorage.getItem('w98-icon-pos') || '{}');
              p[def.id] = { x: icon.offsetLeft, y: icon.offsetTop };
              localStorage.setItem('w98-icon-pos', JSON.stringify(p));
            }
            document.removeEventListener('mousemove', move);
            document.removeEventListener('mouseup',   up);
          };

          document.addEventListener('mousemove', move);
          document.addEventListener('mouseup',   up);
        });

        icon.addEventListener('click', () => {
          if (didDrag) { didDrag = false; return; }
          document.querySelectorAll('.w98-icon').forEach(ic => ic.classList.remove('selected'));
          icon.classList.add('selected');
          handleIcon(def);
        });
      }

      /* ── Keyboard (both modes) ── */
      icon.addEventListener('keydown', e => {
        if (e.key === 'Enter' || e.key === ' ') handleIcon(def);
      });

      iconParent.appendChild(icon);
    });
  }

  function handleIcon(def) {
    document.querySelectorAll('.w98-icon').forEach(i => i.classList.remove('selected'));
    if      (def.action === 'recycleBin')   openRecycleBin();
    else if (def.action === 'myShop')       openMyShopWindow();
    else if (def.action === 'merch')        openMerchWindow();
    else if (def.action === 'commissions')  openCommissions();
    else if (def.action === 'youtube')      openYouTube();
    else if (def.action === 'eggGame')      openEggGame();
    else if (def.action === 'gwakWord')     openGwakWord();
    else if (def.action === 'about')        openAbout();
    else if (def.action === 'showDesktop')  showDesktop();
    else if (def.url)                       openPageWin('win-' + def.id, def.title || def.label, def.glyph, def.url);
  }

  function showDesktop() {
    wins.forEach((s, id) => { if (!s.minified) minimizeWin(id); });
  }

  /* ============================================================
     TASKBAR
     ============================================================ */
  function buildTaskbar() {
    const startBtn = h('button', {
      id: 'w98-start-btn', type: 'button',
      title: 'Click here to begin',
      '$click': toggleStartMenu,
    },
      h('span', { css: { fontSize: '16px' } }, '🪟'),
      h('span', {}, ' Start')
    );

    const ql = h('div', { id: 'w98-ql' });
    CFG.quickLaunch.forEach(item => {
      ql.appendChild(h('button', {
        cls: 'w98-ql-btn', type: 'button', title: item.label,
        '$click': () => handleIcon(item),
      }, h('span', { css: { fontSize: '14px' } }, item.glyph)));
    });

    tbWindowsEl = h('div', { id: 'w98-tb-windows' });

    const clockEl = h('div', { id: 'w98-tray' });
    const tick = () => {
      const n = new Date();
      clockEl.textContent = String(n.getHours()).padStart(2, '0') + ':' + String(n.getMinutes()).padStart(2, '0');
    };
    tick(); setInterval(tick, 1000);

    document.body.appendChild(
      h('div', { id: 'w98-taskbar' },
        startBtn,
        h('div', { cls: 'w98-grip' }),
        ql,
        h('div', { cls: 'w98-grip' }),
        tbWindowsEl,
        clockEl
      )
    );
  }

  /* ============================================================
     START MENU
     ============================================================ */
  /* ── Product search launched from Start Menu search bar ── */
  function openSearchWin(query) {
    if (!query || !query.trim()) return;
    query = query.trim();
    const WIN_ID = 'w98-search-' + query.toLowerCase().replace(/\s+/g, '-');

    const body = document.createElement('div');
    body.style.cssText = 'display:flex;flex-direction:column;flex:1;min-height:0;padding:8px;background:#fff;font-family:var(--w98-font);font-size:12px;overflow-y:auto;';

    // Loading state
    const loading = document.createElement('div');
    loading.style.cssText = 'padding:16px;color:#444;';
    loading.textContent = 'Searching for "' + query + '"…';
    body.appendChild(loading);

    _openWin({ id: WIN_ID, title: 'Search: ' + query, glyph: '🔍', body, pos: nextPos(), w: 420, h: 340 });

    // Shopify product search API — no auth needed
    fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=10')
      .then(function(r) { return r.json(); })
      .then(function(data) {
        loading.remove();
        const products = (data.resources && data.resources.results && data.resources.results.products) || [];
        if (products.length === 0) {
          const none = document.createElement('div');
          none.style.cssText = 'padding:24px;text-align:center;color:#888;';
          none.innerHTML = '<div style="font-size:28px;margin-bottom:8px;">🔍</div><div>No results for "' + query + '"</div>';
          body.appendChild(none);
          return;
        }
        products.forEach(function(p) {
          const row = document.createElement('div');
          row.style.cssText = 'display:flex;align-items:center;gap:8px;padding:6px 4px;border-bottom:1px solid #ddd;cursor:pointer;';
          row.onmouseover = function() { row.style.background = '#000080'; row.style.color = '#fff'; };
          row.onmouseout  = function() { row.style.background = ''; row.style.color = ''; };

          // Thumbnail
          const img = document.createElement('img');
          img.src = p.image ? p.image.url : '';
          img.style.cssText = 'width:40px;height:40px;object-fit:cover;flex-shrink:0;border:1px solid #ccc;';
          img.onerror = function() { img.style.display = 'none'; };

          // Info
          const info = document.createElement('div');
          info.style.cssText = 'flex:1;min-width:0;';
          const title = document.createElement('div');
          title.style.cssText = 'font-weight:bold;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;';
          title.textContent = p.title;
          const price = document.createElement('div');
          price.style.cssText = 'color:#555;';
          price.textContent = p.price ? '$' + parseFloat(p.price).toFixed(2) : '';

          info.appendChild(title);
          info.appendChild(price);
          row.appendChild(img);
          row.appendChild(info);

          row.addEventListener('click', function() {
            openPageWin('win-product-' + p.id, p.title, '🛍️', p.url);
          });
          body.appendChild(row);
        });
      })
      .catch(function() {
        loading.textContent = 'Search failed. Please try again.';
      });
  }

  function buildStartMenu() {
    const items = h('div', { cls: 'w98-sm-items' });

    // ── Search bar at top of Start Menu ──────────────────────────
    const searchWrap = document.createElement('div');
    searchWrap.style.cssText = 'display:flex;align-items:center;gap:4px;padding:6px 8px;border-bottom:1px solid #808080;background:#d4d0c8;';
    const searchInput = document.createElement('input');
    searchInput.type = 'text';
    searchInput.placeholder = 'Search products…';
    searchInput.style.cssText = 'flex:1;font-family:var(--w98-font);font-size:11px;padding:2px 4px;border:2px inset #808080;background:#fff;outline:none;';
    const searchBtn = document.createElement('button');
    searchBtn.type = 'button';
    searchBtn.textContent = '🔍';
    searchBtn.style.cssText = 'font-size:13px;padding:1px 5px;cursor:pointer;border:2px outset #d4d0c8;background:#d4d0c8;';
    const doSearch = function() {
      closeStartMenu();
      openSearchWin(searchInput.value);
      searchInput.value = '';
    };
    searchBtn.addEventListener('click', doSearch);
    searchInput.addEventListener('keydown', function(e) { if (e.key === 'Enter') doSearch(); });
    searchWrap.appendChild(searchInput);
    searchWrap.appendChild(searchBtn);
    items.appendChild(searchWrap);

    // Windows Update (italic — Win98 exclusive)
    items.appendChild(h('div', { cls: 'w98-sm-update' },
      h('span', { css: { fontSize: '16px' } }, '🌐'), ' Windows Update'
    ));
    items.appendChild(h('div', { cls: 'w98-sm-divider' }));

    // "Store Info" flyout — groups About This Store + the legal pages
    // under one collapsible row instead of eating five rows of space.
    // Kept right at the top since that's where eyes land first when
    // the menu opens. Clicking the row itself just expands/collapses
    // it in place (the Start menu stays open); clicking one of the
    // items inside it navigates and closes the menu, same as everything else.
    const submenuArrow = h('span', { css: { marginLeft: 'auto', fontSize: '10px', flexShrink: '0' } }, '▶\uFE0E');
    const submenuBody = h('div', {
      cls: 'w98-sm-submenu',
      css: {
        display: 'none',
        paddingLeft: '14px',
        marginLeft: '13px',
        borderLeft: '2px solid #808080',
      }
    });

    const storeInfoItems = [
      { label: 'About This Store', glyph: 'ℹ️', onClick: () => openAbout() },
    ].concat(CFG.legalItems.map(item => ({
      label: item.label,
      glyph: item.glyph,
      onClick: () => openPageWin('win-nav-' + item.label, item.label, item.glyph, item.url),
    })));

    storeInfoItems.forEach(item => {
      submenuBody.appendChild(h('div', {
        cls: 'w98-sm-item',
        '$click': () => { closeStartMenu(); item.onClick(); }
      },
        h('span', { css: { fontSize: '16px', width: '22px', textAlign: 'center', flexShrink: '0' } }, item.glyph),
        h('span', {}, item.label)
      ));
    });

    items.appendChild(h('div', {
      cls: 'w98-sm-item',
      '$click': (e) => {
        e.stopPropagation();
        const isOpen = submenuBody.style.display !== 'none';
        submenuBody.style.display = isOpen ? 'none' : 'block';
        submenuArrow.textContent = isOpen ? '▶\uFE0E' : '▼\uFE0E';
      }
    },
      h('span', { css: { fontSize: '18px', width: '26px', textAlign: 'center', flexShrink: '0' } }, '📁'),
      h('span', { css: { flex: '1' } }, 'Store Info'),
      submenuArrow
    ));
    items.appendChild(submenuBody);

    items.appendChild(h('div', { cls: 'w98-sm-divider' }));

    // Shopping essentials next — the links visitors came here for.
    CFG.navItems.forEach(item => {
      items.appendChild(h('div', {
        cls: 'w98-sm-item',
        '$click': () => { closeStartMenu(); openPageWin('win-nav-' + item.label, item.label, item.glyph, item.url); }
      },
        h('span', { css: { fontSize: '18px', width: '26px', textAlign: 'center', flexShrink: '0' } }, item.glyph),
        h('span', {}, item.label)
      ));
    });

    // Fun/engagement items last, right before the bottom of the menu —
    // these are the ones we actually want people clicking, and the
    // bottom of a dropdown is often the first thing eyes catch.
    items.appendChild(h('div', { cls: 'w98-sm-divider' }));
    items.appendChild(h('div', {
      cls: 'w98-sm-item',
      '$click': () => { closeStartMenu(); openNewsletterWin(); }
    },
      h('span', { css: { fontSize: '18px', width: '26px', textAlign: 'center', flexShrink: '0' } }, '📬'),
      h('span', {}, 'Subscribe to Newsletter')
    ));
    items.appendChild(h('div', {
      cls: 'w98-sm-item',
      id: 'gay-mode-btn',
      '$click': () => { closeStartMenu(); toggleGayMode(); }
    },
      h('span', { css: { fontSize: '18px', width: '26px', textAlign: 'center', flexShrink: '0' } }, '🌈'),
      h('span', {}, 'Gay Mode')
    ));

    smEl = h('div', { id: 'w98-start-menu' },
      h('div', { cls: 'w98-sm-stripe' }, h('span', {}, 'Windows 98')),
      items
    );
    document.body.appendChild(smEl);
  }

  function openStartMenu()  { smEl.classList.add('w98-open');    document.getElementById('w98-start-btn').classList.add('w98-active'); }
  function closeStartMenu() { smEl.classList.remove('w98-open'); document.getElementById('w98-start-btn').classList.remove('w98-active'); }
  function toggleStartMenu() { smEl.classList.contains('w98-open') ? closeStartMenu() : openStartMenu(); }

  /* ============================================================
     GAY MODE — Pride rainbow theme toggle
     Activated from Start Menu → "Make Everything Gay"
     ============================================================ */
  var _gayModeOn      = false;
  var _gayAnimId      = null;
  var _gayTrailFn     = null;   // mousemove listener for rainbow trail
  var _gayTrailIdx    = 0;      // cycles through rainbow colours

  function toggleGayMode() {
    _gayModeOn = !_gayModeOn;
    _gayModeOn ? _gayActivate() : _gayDeactivate();

    // Update Start Menu button label
    var btn = document.getElementById('gay-mode-btn');
    if (btn) {
      var lbl = btn.querySelector('span:last-child');
      if (lbl) lbl.textContent = _gayModeOn ? 'Gay Mode: Off' : 'Gay Mode';
    }
  }

  /* Gay Mode audio ─────────────────────────────────────────────────
     Priority 1 (all devices, including iPhone):
       Set CFG.gayModeSoundUrl to a Shopify-hosted MP3 trimmed to 12s.
       new Audio() respects the user-gesture that triggered Gay Mode.
     Priority 2 (desktop only fallback while no MP3 is uploaded):
       Hidden YouTube iframe — plays on desktop, not on iOS.        */
  var _gayAudio   = null;
  var _gayYtWrap  = null;
  var _gayCtx     = null;  // Web Audio API context for iOS scheduled playback
  var _gayCtxSrc  = null;  // Web Audio source node (so we can stop it)

  function _playGaySound() {
    if (CFG.gayModeSoundUrl) {
      // ── MP3 route — works on every device including iOS ───────
      // iOS requires audio.play() to be called directly in the tap handler.
      // On mobile we call this immediately (no setTimeout), so it stays
      // within the gesture context. On desktop we use the 6500ms delay.
      try {
        if (_gayAudio) { _gayAudio.pause(); _gayAudio = null; }
        _gayAudio = new Audio(CFG.gayModeSoundUrl);
        _gayAudio.loop = false;
        _gayAudio.volume = 1;
        _gayAudio.play().catch(function() {});
        // Stop after exactly 2 seconds
        var _gayAudioRef = _gayAudio;
        setTimeout(function() {
          if (_gayAudioRef) { _gayAudioRef.pause(); _gayAudioRef.currentTime = 0; }
        }, 2000);
      } catch(e) {}
    } else if (!isMobile()) {
      // ── Desktop fallback: hidden YouTube iframe ───────────────
      // start=12, end=15 → plays exactly 3 seconds then stops
      setTimeout(function() {
        if (_gayYtWrap) { _gayYtWrap.remove(); _gayYtWrap = null; }
        var wrap = document.createElement('div');
        _gayYtWrap = wrap;
        wrap.style.cssText = 'position:fixed;left:-9999px;top:-9999px;width:2px;height:2px;overflow:hidden;pointer-events:none;z-index:-9999;';
        var fr = document.createElement('iframe');
        fr.src = 'https://www.youtube.com/embed/paq6sVkkEg0' +
                 '?start=12&end=14&autoplay=1&controls=0&rel=0&playsinline=1&modestbranding=1&disablekb=1&mute=0';
        fr.allow = 'autoplay; encrypted-media';
        fr.style.cssText = 'width:2px;height:2px;border:none;display:block;';
        wrap.appendChild(fr);
        document.body.appendChild(wrap);
        // Remove iframe after 5s (3s clip + buffer)
        setTimeout(function() { if (wrap.parentNode) wrap.remove(); }, 5000);
      }, 7000);  // fires after the fairytale harp sound finishes
    }
  }

  function _stopGaySound() {
    if (_gayAudio) { _gayAudio.pause(); _gayAudio.currentTime = 0; _gayAudio = null; }
    if (_gayYtWrap) { _gayYtWrap.remove(); _gayYtWrap = null; }
    if (_gayCtxSrc) { try { _gayCtxSrc.stop(); } catch(e) {} _gayCtxSrc = null; }
    if (_gayCtx)    { try { _gayCtx.close();  } catch(e) {} _gayCtx    = null; }
  }

  function _gayActivate() {
    // ── 0. Gay mode audio ─────────────────────────────────────────
    if (CFG.gayModeSoundUrl) {
      if (isMobile()) {
        // iOS: use Web Audio API — unlock AudioContext in the gesture,
        // then schedule playback 6s later (1s after the ~5s fairy sound).
        try {
          var AudioCtx = window.AudioContext || window.webkitAudioContext;
          if (AudioCtx) {
            if (_gayCtx) { try { _gayCtx.close(); } catch(e) {} }
            _gayCtx = new AudioCtx();
            _gayCtxSrc = null;
            fetch(CFG.gayModeSoundUrl)
              .then(function(r) { return r.arrayBuffer(); })
              .then(function(buf) { return _gayCtx.decodeAudioData(buf); })
              .then(function(decoded) {
                if (!_gayCtx) return;  // deactivated before fetch finished
                _gayCtxSrc = _gayCtx.createBufferSource();
                _gayCtxSrc.buffer = decoded;
                _gayCtxSrc.connect(_gayCtx.destination);
                var startAt = _gayCtx.currentTime + 6.0;   // 1s after fairy sound
                _gayCtxSrc.start(startAt);
                _gayCtxSrc.stop(startAt + 2.0);            // play for 2 seconds
              })
              .catch(function() {});
          }
        } catch(e) {}
      } else {
        // Desktop: simple setTimeout — no iOS gesture restriction
        setTimeout(_playGaySound, 6500);
      }
    }

    // ── 0b. Giant rainbow background ─────────────────────────────
    buildDesktopRainbow();

    // ── 1. Build custom cursor SVG (pink plug shape) ──────────────
    // Cursor SVG — rotated -35° so tip aims top-left; hotspot at top-left corner
    var plugSvg = [
      '<svg xmlns="http://www.w3.org/2000/svg" width="44" height="56" viewBox="0 0 44 56">',
      '<g transform="rotate(-35,22,28)">',
      // base disc
      '<ellipse cx="22" cy="51" rx="13" ry="4" fill="#e0609a" stroke="#111" stroke-width="1.8"/>',
      // neck/stem
      '<path d="M16 40 C14 44 14 48 22 50 C30 48 30 44 28 40" fill="#e0609a" stroke="#111" stroke-width="1.5"/>',
      // main body — tall rounded egg
      '<path d="M22 4 C12 4 9 16 9 25 C9 36 14 40 22 40 C30 40 35 36 35 25 C35 16 32 4 22 4 Z" fill="#ff82b4" stroke="#111" stroke-width="2.5"/>',
      // shine highlight
      '<ellipse cx="15" cy="16" rx="3" ry="6" fill="rgba(255,255,255,0.52)" transform="rotate(-12,15,16)"/>',
      '</g>',
      '</svg>'
    ].join('');
    var cursorUrl = 'url("data:image/svg+xml,' + encodeURIComponent(plugSvg) + '") 4 4';

    // ── 2. Inject rainbow CSS ────────────────────────────────────
    var css = [
      '@keyframes gay-float   { 0%,100%{transform:translateY(0) rotate(-5deg)} 50%{transform:translateY(-10px) rotate(5deg)} }',
      '@keyframes gay-spin    { to{transform:rotate(360deg)} }',
      '@keyframes gay-pulse   { 0%,100%{opacity:1} 50%{opacity:0.5} }',
      '@keyframes gay-bg      { 0%{background-position:0% 50%} 50%{background-position:100% 50%} 100%{background-position:0% 50%} }',
      '@keyframes gay-rainbow { 0%{filter:hue-rotate(0deg) saturate(3)} 100%{filter:hue-rotate(360deg) saturate(3)} }',

      /* Desktop background */
      '#w98-desktop { background: linear-gradient(135deg,#ff9ecd,#ffb3c1,#c3b1e1,#b5d5f5,#b3ffda,#ffffc2,#ffb3c1) !important;',
      '  background-size: 400% 400% !important; animation: gay-bg 8s ease infinite !important; }',

      /* Window title bars — rainbow gradient */
      '.w98-win__titlebar { background: linear-gradient(90deg,#FF0000,#FF7700,#FFFF00,#00CC00,#0077FF,#8B00FF) !important; }',
      '.w98-win__titlebar * { text-shadow: 0 0 6px #fff !important; }',

      /* Win borders pink glow */
      '.w98-win { border-color: #FF69B4 !important; box-shadow: 0 0 12px rgba(255,105,180,0.6) !important; }',

      /* Taskbar */
      '#w98-taskbar { background: linear-gradient(90deg,#FF69B4,#DA70D6,#FF69B4) !important;',
      '  border-top: 2px solid #FF1493 !important; }',

      /* Start button */
      '#w98-start-btn { background: linear-gradient(135deg,#FF69B4,#DA70D6) !important;',
      '  border-color: #FF1493 #C71585 #C71585 #FF1493 !important; }',

      /* Icon labels — white with pink glow */
      '.w98-icon__label { color: #fff !important; text-shadow: 0 0 6px #FF1493, 1px 1px 0 #8B0057 !important; }',

      /* Icons — hue-rotate cycling */
      '.w98-icon__glyph--svg { animation: gay-rainbow 4s linear infinite !important; }',
      '.w98-icon__glyph { animation: gay-pulse 1.5s ease-in-out infinite !important; }',

      /* Taskbar window buttons pink */
      '.w98-tb-btn { background: #FF69B4 !important; border-color: #FFC0E0 #C71585 #C71585 #FFC0E0 !important; }',
      '.w98-tb-btn.w98-active { background: #C71585 !important; }',

      /* Custom plug cursor — only while gay mode is on */
      '*, *::before, *::after { cursor: ' + cursorUrl + ', auto !important; }',
    ].join('\n');

    var styleEl = document.createElement('style');
    styleEl.id  = 'gay-mode-css';
    styleEl.textContent = css;
    document.head.appendChild(styleEl);

    // ── 2. Floating flowers & sparkles on desktop ─────────────────
    var desktop = document.getElementById('w98-desktop');
    var decos   = ['🌸','🌺','🌹','🌷','💐','🦋','✨','💖','💅','🌈','🌼','💎','⭐','🌟','💃'];
    if (desktop) {
      for (var i = 0; i < 18; i++) {
        var d = document.createElement('div');
        d.className = 'gay-deco';
        d.textContent = decos[i % decos.length];
        d.style.cssText = [
          'position:absolute',
          'left:'  + (3 + Math.random() * 90) + '%',
          'top:'   + (3 + Math.random() * 82) + '%',
          'font-size:' + (14 + Math.floor(Math.random() * 18)) + 'px',
          'pointer-events:none',
          'z-index:500',
          'user-select:none',
          'animation:gay-float ' + (2 + Math.random() * 3).toFixed(1) + 's ease-in-out infinite',
          'animation-delay:' + (Math.random() * 3).toFixed(1) + 's',
        ].join(';');
        desktop.appendChild(d);
      }
    }

    // ── 3. Glitter canvas overlay ─────────────────────────────────
    var canvas = document.createElement('canvas');
    canvas.id  = 'gay-glitter';
    canvas.style.cssText = [
      'position:fixed','top:0','left:0',
      'width:100%','height:100%',
      'pointer-events:none','z-index:88888'
    ].join(';');
    canvas.width  = window.innerWidth;
    canvas.height = window.innerHeight;
    document.body.appendChild(canvas);

    var ctx    = canvas.getContext('2d');
    var COLORS = ['#FF0000','#FF7700','#FFFF00','#00DD00','#0099FF','#8B00FF',
                  '#FF69B4','#FFFFFF','#FFD700','#FF1493'];
    var parts  = [];
    for (var p = 0; p < 90; p++) {
      parts.push({
        x:     Math.random() * canvas.width,
        y:     Math.random() * canvas.height,
        r:     Math.random() * 3 + 1,
        color: COLORS[Math.floor(Math.random() * COLORS.length)],
        speed: Math.random() * 1.4 + 0.4,
        dx:    (Math.random() - 0.5) * 0.7,
        life:  Math.random() * Math.PI * 2,
        angle: Math.random() * Math.PI * 2,
        spin:  (Math.random() - 0.5) * 0.14,
      });
    }

    function glitterLoop() {
      if (!_gayModeOn) return;
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      for (var j = 0; j < parts.length; j++) {
        var q = parts[j];
        q.y     += q.speed;
        q.x     += q.dx;
        q.life  += 0.035;
        q.angle += q.spin;
        if (q.y > canvas.height) { q.y = -4; q.x = Math.random() * canvas.width; }
        if (q.x < 0 || q.x > canvas.width) q.dx *= -1;
        ctx.save();
        ctx.globalAlpha = Math.sin(q.life) * 0.45 + 0.55;
        ctx.fillStyle   = q.color;
        ctx.translate(q.x, q.y);
        ctx.rotate(q.angle);
        ctx.fillRect(-q.r, -q.r, q.r * 2, q.r * 2);
        ctx.restore();
      }
      _gayAnimId = requestAnimationFrame(glitterLoop);
    }
    glitterLoop();

    // ── 4. Rainbow cursor trail ───────────────────────────────────
    var TRAIL_COLORS = ['#FF0000','#FF8800','#FFEE00','#00CC44','#22AAFF','#9900CC','#FF69B4'];
    _gayTrailFn = function(e) {
      var c = TRAIL_COLORS[_gayTrailIdx % TRAIL_COLORS.length];
      _gayTrailIdx++;
      var sz = 12 + Math.random() * 8;
      var dot = document.createElement('div');
      dot.className = 'gay-trail-dot';
      dot.style.cssText = [
        'position:fixed',
        'pointer-events:none',
        'z-index:2147483646',
        'border-radius:50%',
        'width:'  + sz + 'px',
        'height:' + sz + 'px',
        'left:' + (e.clientX - sz/2) + 'px',
        'top:'  + (e.clientY - sz/2) + 'px',
        'background:' + c,
        'opacity:0.92',
        'box-shadow:0 0 6px 2px ' + c,
        'transition:opacity 0.55s ease,transform 0.55s ease',
        'transform:scale(1)'
      ].join(';');
      document.body.appendChild(dot);
      // Double rAF so transition fires after element is painted
      requestAnimationFrame(function() {
        requestAnimationFrame(function() {
          dot.style.opacity = '0';
          dot.style.transform = 'scale(0.15)';
        });
      });
      setTimeout(function() { if (dot.parentNode) dot.remove(); }, 600);
    };
    document.addEventListener('mousemove', _gayTrailFn);

    // ── 5. Launch unicorn across screen ──────────────────────────
    launchUnicorn();
  }

  function _gayDeactivate() {
    // Remove CSS
    var s = document.getElementById('gay-mode-css');
    if (s) s.remove();

    // Stop glitter
    if (_gayAnimId) { cancelAnimationFrame(_gayAnimId); _gayAnimId = null; }
    var c = document.getElementById('gay-glitter');
    if (c) c.remove();

    // Remove flowers
    document.querySelectorAll('.gay-deco').forEach(function(el) { el.remove(); });

    // Remove rainbow cursor trail listener + any lingering dots
    if (_gayTrailFn) {
      document.removeEventListener('mousemove', _gayTrailFn);
      _gayTrailFn = null;
    }
    document.querySelectorAll('.gay-trail-dot').forEach(function(el) { el.remove(); });

    // Remove rainbow background
    var rb = document.getElementById('w98-rainbow-bg');
    if (rb) rb.remove();

    // Stop gay mode music
    _stopGaySound();
  }

  /* ============================================================
     UNICORN — drawn cartoon unicorn flies across screen
     leaving a rainbow trail with fairytale sparkle sound.
     Auto-triggered when Gay Mode activates.
     ============================================================ */

  /* Leg helper — stubby cartoon horse leg with dark hoof */
  function _drawLeg(ctx, x, y, lineCol, bodyCol, hoofCol, lw) {
    // Upper leg
    ctx.beginPath();
    ctx.moveTo(x+4, y);
    ctx.lineTo(x+4, y+38);
    ctx.arc(x+11, y+38, 7, Math.PI, 0);
    ctx.lineTo(x+18, y);
    ctx.closePath();
    ctx.fillStyle = bodyCol; ctx.fill(); ctx.strokeStyle = lineCol; ctx.lineWidth = lw; ctx.stroke();
    // Hoof
    ctx.beginPath();
    ctx.moveTo(x+2, y+38);
    ctx.lineTo(x+2, y+50);
    ctx.arc(x+11, y+50, 9, Math.PI, 0);
    ctx.lineTo(x+20, y+38);
    ctx.closePath();
    ctx.fillStyle = hoofCol; ctx.fill(); ctx.strokeStyle = lineCol; ctx.lineWidth = lw; ctx.stroke();
  }

  /* Purple cartoon horse unicorn — matches the reference sticker image.
     Large, transparent (canvas = cut-out), facing right.
     sc = scale  |  t = elapsed seconds for animation */
  function _drawUnicorn(ctx, sc, t) {
    ctx.save();
    ctx.scale(sc, sc);

    var bob = Math.sin(t * 2.5) * 5;
    ctx.translate(0, bob);

    var BODY  = '#C87DD8';   // medium purple
    var LINE  = '#222222';   // dark outline
    var MANE  = '#CC3355';   // deep pink-red
    var MANE2 = '#E8607A';   // lighter pink
    var HOOF  = '#55556A';   // dark gray
    var LW    = 3.5;

    // ── TAIL (draw first — behind body) ──────────────────────────
    [
      { sw: 22, c: MANE,  ox: 0 },
      { sw: 11, c: MANE2, ox: 3 },
    ].forEach(function(m) {
      ctx.beginPath();
      ctx.moveTo(-68 + m.ox, 10);
      ctx.bezierCurveTo(
        -98, 32 + Math.sin(t*2.2)*9,
        -100, 65,
        -74 + Math.sin(t*2.8)*12, 82
      );
      ctx.strokeStyle = m.c; ctx.lineWidth = m.sw; ctx.lineCap = 'round'; ctx.stroke();
    });

    // ── BACK LEGS ────────────────────────────────────────────────
    _drawLeg(ctx, -35, 35, LINE, BODY, HOOF, LW);
    _drawLeg(ctx, -13, 37, LINE, BODY, HOOF, LW);

    // ── BODY ─────────────────────────────────────────────────────
    ctx.beginPath(); ctx.ellipse(-5, 10, 68, 47, 0, 0, Math.PI*2);
    ctx.fillStyle = BODY; ctx.fill(); ctx.strokeStyle = LINE; ctx.lineWidth = LW; ctx.stroke();

    // ── FRONT LEGS ───────────────────────────────────────────────
    _drawLeg(ctx, 25, 35, LINE, BODY, HOOF, LW);
    _drawLeg(ctx, 47, 33, LINE, BODY, HOOF, LW);

    // ── NECK ─────────────────────────────────────────────────────
    ctx.beginPath();
    ctx.moveTo(40, -18);
    ctx.bezierCurveTo(52, -44, 58, -50, 65, -40);
    ctx.bezierCurveTo(60, -18, 52, -8, 44, -5);
    ctx.closePath();
    ctx.fillStyle = BODY; ctx.fill(); ctx.strokeStyle = LINE; ctx.lineWidth = LW; ctx.stroke();

    // ── HEAD ─────────────────────────────────────────────────────
    ctx.beginPath(); ctx.arc(72, -34, 38, 0, Math.PI*2);
    ctx.fillStyle = BODY; ctx.fill(); ctx.strokeStyle = LINE; ctx.lineWidth = LW; ctx.stroke();

    // ── MANE — thick pink-red flowing from horn base over neck ───
    [
      { sw: 26, c: MANE  },
      { sw: 14, c: MANE2 },
    ].forEach(function(m) {
      ctx.beginPath();
      ctx.moveTo(64, -70);
      ctx.bezierCurveTo(
        40, -54 + Math.sin(t*2)*6,
        20, -28 + Math.cos(t*1.8)*5,
        2, 10
      );
      ctx.strokeStyle = m.c; ctx.lineWidth = m.sw; ctx.lineCap = 'round'; ctx.stroke();
    });
    // Forehead tuft that falls forward (matching image)
    [
      { sw: 16, c: MANE  },
      { sw:  8, c: MANE2 },
    ].forEach(function(m) {
      ctx.beginPath();
      ctx.moveTo(65, -70);
      ctx.bezierCurveTo(
        86, -60 + Math.sin(t*2.5)*4,
        104, -44,
        100, -28
      );
      ctx.strokeStyle = m.c; ctx.lineWidth = m.sw; ctx.lineCap = 'round'; ctx.stroke();
    });

    // ── HORN — dark spiral pointing up ───────────────────────────
    ctx.beginPath();
    ctx.moveTo(58, -68); ctx.lineTo(70, -68); ctx.lineTo(63, -112); ctx.closePath();
    ctx.fillStyle = '#333344'; ctx.fill(); ctx.strokeStyle = LINE; ctx.lineWidth = 2; ctx.stroke();
    for (var h = 0; h < 5; h++) {
      ctx.beginPath();
      ctx.moveTo(68 - h*1.5, -70 - h*8);
      ctx.lineTo(59 + h*0.5, -73 - h*8);
      ctx.strokeStyle = 'rgba(0,0,0,0.3)'; ctx.lineWidth = 1.2; ctx.stroke();
    }

    // ── EAR ──────────────────────────────────────────────────────
    ctx.beginPath();
    ctx.moveTo(50,-60); ctx.lineTo(44,-80); ctx.lineTo(62,-66); ctx.closePath();
    ctx.fillStyle = '#D8A0E8'; ctx.fill(); ctx.strokeStyle = LINE; ctx.lineWidth = LW; ctx.stroke();
    ctx.beginPath();
    ctx.moveTo(51,-62); ctx.lineTo(47,-74); ctx.lineTo(60,-67); ctx.closePath();
    ctx.fillStyle = MANE2; ctx.fill();

    // ── EYES — big googly cartoon circles (matching image) ───────
    // Far eye
    ctx.beginPath(); ctx.arc(90, -36, 15, 0, Math.PI*2);
    ctx.fillStyle = '#fff'; ctx.fill(); ctx.strokeStyle = LINE; ctx.lineWidth = LW; ctx.stroke();
    ctx.beginPath(); ctx.arc(92, -34, 9, 0, Math.PI*2);
    ctx.fillStyle = '#111'; ctx.fill();
    ctx.beginPath(); ctx.arc(95, -37, 2.8, 0, Math.PI*2);
    ctx.fillStyle = '#fff'; ctx.fill();
    // Near eye (bigger)
    ctx.beginPath(); ctx.arc(66, -38, 17, 0, Math.PI*2);
    ctx.fillStyle = '#fff'; ctx.fill(); ctx.strokeStyle = LINE; ctx.lineWidth = LW; ctx.stroke();
    ctx.beginPath(); ctx.arc(68, -36, 11, 0, Math.PI*2);
    ctx.fillStyle = '#111'; ctx.fill();
    ctx.beginPath(); ctx.arc(72, -40, 3.5, 0, Math.PI*2);
    ctx.fillStyle = '#fff'; ctx.fill();

    // ── NOSTRIL ──────────────────────────────────────────────────
    ctx.beginPath(); ctx.ellipse(103, -17, 4.5, 3.5, 0.3, 0, Math.PI*2);
    ctx.fillStyle = '#A858C8'; ctx.fill();

    // ── SMILE ────────────────────────────────────────────────────
    ctx.beginPath();
    ctx.arc(98, -12, 8, 0.1, Math.PI - 0.1);
    ctx.strokeStyle = LINE; ctx.lineWidth = 2.5; ctx.lineCap = 'round'; ctx.stroke();

    ctx.restore();
  }

  function launchUnicorn() {
    var old = document.getElementById('unicorn-canvas');
    if (old) old.remove();

    var W = window.innerWidth  || 800;
    var H = window.innerHeight || 600;

    var cvs = document.createElement('canvas');
    cvs.id  = 'unicorn-canvas';
    cvs.width  = W;
    cvs.height = H;
    cvs.style.cssText = 'position:fixed;top:0;left:0;width:100%;height:100%;pointer-events:none;z-index:2147483647;';
    document.body.appendChild(cvs);
    var ctx = cvs.getContext('2d');

    // ── Preload sticker image if URL is set ───────────────────────
    var _uImg = null;
    var _uImgReady = false;
    if (CFG.unicornImageUrl) {
      _uImg = new Image();
      _uImg.crossOrigin = 'anonymous';
      _uImg.onload  = function() { _uImgReady = true; };
      _uImg.onerror = function() { _uImgReady = false; _uImg = null; };
      _uImg.src = CFG.unicornImageUrl;
    }

    // 6 concentric bezier arcs — red outermost, violet innermost
    var S = [
      { c:'#FF0000', sy:H*0.90, py:H*-0.10 },
      { c:'#FF8800', sy:H*0.84, py:H*-0.03 },
      { c:'#FFEE00', sy:H*0.78, py:H* 0.04 },
      { c:'#00BB00', sy:H*0.72, py:H* 0.11 },
      { c:'#2299FF', sy:H*0.66, py:H* 0.18 },
      { c:'#9900CC', sy:H*0.60, py:H* 0.25 },
    ];

    // Quadratic bezier point
    function bz(t, sy, py) {
      var u = 1 - t;
      return {
        x: u*u*(-120) + 2*u*t*(W/2) + t*t*(W+120),
        y: u*u*sy     + 2*u*t*py    + t*t*sy
      };
    }

    var STEPS    = 80;
    var DURATION = 4500;
    var t0       = null;
    var sparks   = [];
    var SC       = ['#FF0000','#FF8800','#FFEE00','#00BB00','#2299FF','#9900CC','#FF69B4','#FFD700','#ffffff'];

    // ── Fairytale harp sound ──────────────────────────────────────
    _unicornSound();

    // (Gay Mode music is handled by _playGaySound() in _gayActivate)

    function tick(now) {
      if (!t0) t0 = now;
      var prog    = Math.min((now - t0) / DURATION, 1);
      var steps   = Math.round(prog * STEPS);
      var elapsed = (now - t0) / 1000;

      ctx.clearRect(0, 0, W, H);

      // ── LARGE rainbow arcs behind unicorn ─────────────────────
      for (var si = 0; si < S.length; si++) {
        var stripe = S[si];
        ctx.beginPath();
        ctx.strokeStyle = stripe.c;
        ctx.lineWidth   = 52;   // thick — big rainbow
        ctx.lineCap     = 'round';
        ctx.lineJoin    = 'round';
        for (var i = 0; i <= steps; i++) {
          var p = bz(i / STEPS, stripe.sy, stripe.py);
          (i === 0) ? ctx.moveTo(p.x, p.y) : ctx.lineTo(p.x, p.y);
        }
        ctx.stroke();
      }

      // Unicorn position on arc
      var mid  = S[4];
      var uPos = bz(prog,                    mid.sy, mid.py);
      var uFwd = bz(Math.min(prog+0.01, 1),  mid.sy, mid.py);
      var ang  = Math.atan2(uFwd.y - uPos.y, uFwd.x - uPos.x);

      // Sparkle particles (bigger sparks to match larger scene)
      for (var e = 0; e < 6; e++) {
        sparks.push({
          x:   uPos.x + (Math.random()-0.5)*80,
          y:   uPos.y + (Math.random()-0.5)*80,
          vx:  (Math.random()-0.5)*3,
          vy:  -(Math.random()*3 + 0.5),
          r:   Math.random()*8 + 3,
          a:   1,
          col: SC[Math.floor(Math.random()*SC.length)]
        });
      }
      for (var j = sparks.length-1; j >= 0; j--) {
        var sp = sparks[j];
        ctx.save();
        ctx.globalAlpha = sp.a;
        ctx.fillStyle   = sp.col;
        ctx.beginPath();
        ctx.arc(sp.x, sp.y, sp.r, 0, Math.PI*2);
        ctx.fill();
        ctx.restore();
        sp.x += sp.vx; sp.y += sp.vy;
        sp.a -= 0.024;
        if (sp.a <= 0) sparks.splice(j, 1);
      }

      // ── Draw unicorn — sticker image if loaded, else vector art ──
      var bob = Math.sin(elapsed * 2.5) * 8;
      ctx.save();
      ctx.translate(uPos.x, uPos.y + bob);
      if (_uImgReady && _uImg) {
        // Sticker image: large, upright, no background
        var imgH = Math.min(W, H) * 0.52;
        var imgW = imgH * (_uImg.width / _uImg.height);
        ctx.drawImage(_uImg, -imgW / 2, -imgH / 2, imgW, imgH);
      } else {
        // Vector unicorn: large purple horse
        ctx.rotate(ang);
        var sc = Math.min(W, H) / 340;   // bigger scale
        _drawUnicorn(ctx, sc, elapsed);
      }
      ctx.restore();

      if (prog < 1) {
        requestAnimationFrame(tick);
      } else {
        var opacity = 1;
        var fadeInt = setInterval(function() {
          opacity -= 0.02;
          cvs.style.opacity = String(opacity);
          if (opacity <= 0) { clearInterval(fadeInt); cvs.remove(); }
        }, 40);
      }
    }

    requestAnimationFrame(tick);
  }

  /* Fairytale sparkle sound — pentatonic harp glissando + twinkling dust */
  function _unicornSound() {
    try {
      var actx = new (window.AudioContext || window.webkitAudioContext)();
      var now  = actx.currentTime;

      // Pentatonic magic scale (C maj pentatonic across 3 octaves)
      var NOTES = [523,587,659,784,880,1047,1175,1319,1568,1760,2093];

      // Master reverb (convolver-style using delay feedback)
      var masterGain = actx.createGain();
      masterGain.gain.setValueAtTime(0.8, now);
      masterGain.connect(actx.destination);

      // ── Harp glissando — ascending notes spread over 2 s ─────────
      NOTES.forEach(function(freq, ni) {
        var t    = now + ni * 0.18 + Math.random() * 0.06;
        var osc  = actx.createOscillator();
        var gain = actx.createGain();
        var dly  = actx.createDelay(0.8);
        var dlGain = actx.createGain();

        osc.connect(gain);
        gain.connect(masterGain);
        gain.connect(dly);
        dly.connect(dlGain);
        dlGain.connect(masterGain);
        dlGain.gain.setValueAtTime(0.3, t);
        dly.delayTime.setValueAtTime(0.25, t);

        osc.type = 'triangle';
        osc.frequency.setValueAtTime(freq, t);

        gain.gain.setValueAtTime(0,    t);
        gain.gain.linearRampToValueAtTime(0.12, t + 0.05);
        gain.gain.exponentialRampToValueAtTime(0.001, t + 1.2);

        osc.start(t);
        osc.stop(t + 1.3);
      });

      // ── Second ascending sweep (higher, softer — echo effect) ────
      NOTES.forEach(function(freq, ni) {
        var t    = now + 0.5 + ni * 0.14;
        var osc  = actx.createOscillator();
        var gain = actx.createGain();
        osc.connect(gain); gain.connect(masterGain);
        osc.type = 'sine';
        osc.frequency.setValueAtTime(freq * 2, t);
        gain.gain.setValueAtTime(0, t);
        gain.gain.linearRampToValueAtTime(0.05, t + 0.04);
        gain.gain.exponentialRampToValueAtTime(0.001, t + 0.6);
        osc.start(t); osc.stop(t + 0.65);
      });

      // ── Fairy dust sparkles — random high tones throughout ────────
      for (var i = 0; i < 55; i++) {
        (function() {
          var t    = now + Math.random() * 5;
          var freq = 1400 + Math.random() * 2200;
          var osc  = actx.createOscillator();
          var gain = actx.createGain();
          osc.connect(gain); gain.connect(masterGain);
          osc.type = 'sine';
          osc.frequency.setValueAtTime(freq, t);
          osc.frequency.exponentialRampToValueAtTime(freq * 1.4, t + 0.08);
          gain.gain.setValueAtTime(0,    t);
          gain.gain.linearRampToValueAtTime(0.04, t + 0.03);
          gain.gain.exponentialRampToValueAtTime(0.001, t + 0.3);
          osc.start(t); osc.stop(t + 0.35);
        })();
      }
    } catch(e) {}
  }

  /* ============================================================
     CONTEXT MENU (right-click on teal desktop)
     ============================================================ */
  function buildContextMenu() {
    const menu = h('div', { id: 'w98-ctx' });
    [
      { label: '📋  Arrange Icons',    fn: () => {} },
      { label: '🌐  Active Desktop',   fn: () => {} },
      { label: '🔄  Refresh',          fn: () => location.reload() },
      null,
      { label: 'ℹ️   About ' + CFG.storeName, fn: openAbout },
      { label: '🖼️   Browse Art',  fn: () => openPageWin('win-browse', 'All Art', '🖼️', '/collections/catalog') },
    ].forEach(item => {
      if (!item) { menu.appendChild(h('div', { cls: 'w98-ctx-sep' })); return; }
      const row = h('div', {
        cls: 'w98-ctx-item',
        '$click': () => { menu.classList.remove('w98-open'); item.fn(); }
      }, item.label);
      menu.appendChild(row);
    });
    document.body.appendChild(menu);

    desktop.addEventListener('contextmenu', e => {
      e.preventDefault();
      menu.style.left = Math.min(e.clientX, window.innerWidth  - 200) + 'px';
      menu.style.top  = Math.min(e.clientY, window.innerHeight - 36 - 180) + 'px';
      menu.classList.add('w98-open');
    });

    document.addEventListener('click',   () => menu.classList.remove('w98-open'));
    document.addEventListener('keydown', e => { if (e.key === 'Escape') { menu.classList.remove('w98-open'); closeStartMenu(); } });
  }

  /* ============================================================
     BOOT SCREEN
     ============================================================ */
  function buildBootScreen() {
    if (!CFG.bootScreen || sessionStorage.getItem('w98_booted')) return;
    sessionStorage.setItem('w98_booted', '1');

    /* fill element — inline styles used for image mode so CSS loading order
       cannot interfere with the animation */
    const fill = document.createElement('div');

    let screen;
    if (CFG.bootScreenImage) {
      /* ── Custom image boot screen ── */
      screen = document.createElement('div');
      screen.id = 'w98-boot-screen';
      const bgSize = isMobile() ? 'contain' : 'cover';
      screen.style.cssText = `
        position:fixed;inset:0;z-index:99999;
        background:#000 url("${CFG.bootScreenImage}") center center/${bgSize} no-repeat;
      `;

      /* Progress bar — fully inline so it always renders correctly */
      const barTrack = document.createElement('div');
      barTrack.style.cssText = `
        position:absolute;
        bottom:60px;
        left:50%;
        transform:translateX(-50%);
        width:min(340px, 80vw);
        height:16px;
        background:rgba(0,0,0,0.65);
        border:2px solid rgba(255,255,255,0.45);
        border-radius:3px;
        overflow:hidden;
      `;

      /* Bright gradient fill — clearly visible on any background */
      fill.style.cssText = `
        height:100%;
        width:0%;
        background:linear-gradient(to right,#1155dd,#44aaff);
        display:block;
        transition:width 0.12s linear;
      `;

      barTrack.appendChild(fill);
      screen.appendChild(barTrack);

    } else {
      /* ── Default black boot screen ── */
      fill.className = 'w98-boot-bar-fill';
      screen = h('div', { id: 'w98-boot-screen' },
        h('div', { cls: 'w98-boot-logo' },
          h('div', { cls: 'w98-boot-flag' }, h('span'), h('span'), h('span'), h('span')),
          h('div', { cls: 'w98-boot-title' }, 'Windows 98')
        ),
        h('div', { cls: 'w98-boot-sub' }, 'Starting ' + CFG.storeName + '…'),
        h('div', { cls: 'w98-boot-bar-track' }, fill)
      );
    }
    // ── "Tap to start" prompt (mobile needs a gesture to unlock audio) ──
    const tapPrompt = document.createElement('div');
    tapPrompt.style.cssText = `
      position:absolute;bottom:20px;left:50%;transform:translateX(-50%);
      color:rgba(255,255,255,0.75);font-family:"MS Sans Serif",Arial,sans-serif;
      font-size:13px;letter-spacing:1px;pointer-events:none;
      animation:w98-blink 1.2s ease-in-out infinite;
    `;
    tapPrompt.textContent = 'TAP TO START';

    /* inject blink keyframes once */
    if (!document.getElementById('w98-blink-style')) {
      const st = document.createElement('style');
      st.id = 'w98-blink-style';
      st.textContent = '@keyframes w98-blink{0%,100%{opacity:1}50%{opacity:0.2}}';
      document.head.appendChild(st);
    }
    screen.appendChild(tapPrompt);
    document.body.appendChild(screen);

    // ── Boot sound + animation — both start on first tap/click ──
    let bootAudio = null;
    let started   = false;

    function startBoot() {
      if (started) return;
      started = true;
      tapPrompt.remove();

      /* Play startup sound — gesture already happened so no block */
      if (CFG.bootSoundUrl) {
        bootAudio = new Audio(CFG.bootSoundUrl);
        bootAudio.volume = 0.85;
        bootAudio.play().catch(() => {});
      }

      /* Progress bar animation */
      let pct = 0;
      const iv = setInterval(() => {
        pct += Math.random() * 4 + 2;
        if (pct >= 100) {
          fill.style.width = '100%';
          clearInterval(iv);
          setTimeout(() => {
            screen.style.transition = 'opacity 0.8s';
            screen.style.opacity    = '0';
            /* sound keeps playing naturally after screen fades */
            setTimeout(() => screen.remove(), 800);
          }, 800);
        } else {
          fill.style.width = pct + '%';
        }
      }, 90);
    }

    screen.addEventListener('click',      startBoot);
    screen.addEventListener('touchstart', startBoot, { passive: true });
    document.addEventListener('keydown',  startBoot, { once: true });
  }

  /* ============================================================
     KEYBOARD SHORTCUTS
     ============================================================ */
  function initKeyboard() {
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape') closeStartMenu();
      if ((e.key === 'Meta' || e.code === 'MetaLeft') && !e.ctrlKey) { e.preventDefault(); toggleStartMenu(); }
      if (e.ctrlKey && e.key === 'd') { e.preventDefault(); showDesktop(); }
    });
    document.addEventListener('click', e => {
      if (!smEl?.classList.contains('w98-open')) return;
      const sb = document.getElementById('w98-start-btn');
      if (!smEl.contains(e.target) && !sb?.contains(e.target)) closeStartMenu();
    });
  }

  /* ============================================================
     SCREENSAVER — DVD-bounce logo, activates after idle timeout
     ============================================================ */
  function initScreensaver() {
    /* ── Color palette — vivid, high-contrast hues ── */
    const COLORS = [
      { filter: 'invert(1) sepia(1) saturate(8) hue-rotate(0deg)   brightness(1.4)' },   // gold/yellow
      { filter: 'invert(1) sepia(1) saturate(8) hue-rotate(75deg)  brightness(1.3)' },   // lime green
      { filter: 'invert(1) sepia(1) saturate(8) hue-rotate(150deg) brightness(1.3)' },   // cyan
      { filter: 'invert(1) sepia(1) saturate(8) hue-rotate(195deg) brightness(1.4)' },   // sky blue
      { filter: 'invert(1) sepia(1) saturate(8) hue-rotate(240deg) brightness(1.5)' },   // purple
      { filter: 'invert(1) sepia(1) saturate(8) hue-rotate(290deg) brightness(1.4)' },   // magenta/pink
      { filter: 'invert(1) sepia(1) saturate(8) hue-rotate(330deg) brightness(1.3)' },   // hot red
    ];

    let colorIdx  = 0;
    let animId    = null;
    let idleTimer = null;
    let active    = false;

    /* position & velocity */
    let px = 0, py = 0;
    let vx = 0, vy = 0;
    const LOGO_W = 260;  /* px — display width of the bouncing logo */
    const SPEED  = 2.2;  /* pixels per frame */

    /* ── Build the overlay ── */
    const overlay = document.createElement('div');
    overlay.id = 'w98-screensaver';
    overlay.style.cssText = `
      position: fixed; inset: 0;
      background: #000;
      z-index: 999999;
      display: none;
      cursor: none;
      user-select: none;
    `;

    /* ── Logo element ── */
    const logoWrap = document.createElement('div');
    logoWrap.style.cssText = `
      position: absolute;
      width: ${LOGO_W}px;
      mix-blend-mode: screen;
      pointer-events: none;
    `;

    /* Auto-detect store logo from the page if not set in CFG */
    const _autoLogoEl = !CFG.screensaverLogo
      ? document.querySelector(
          '.header__heading-logo img, .site-header__logo img, ' +
          '.header__logo img, header .logo img, ' +
          'header img[src*="logo"], header img[alt*="logo" i], ' +
          'header img:first-of-type'
        )
      : null;
    const _logoSrc = CFG.screensaverLogo || (_autoLogoEl && _autoLogoEl.src) || null;

    let logoEl;
    if (_logoSrc) {
      /* Use the store logo image — mix-blend-mode:screen makes dark pixels
         transparent so only the logo silhouette glows with the colour filter */
      logoEl = document.createElement('img');
      logoEl.src = _logoSrc;
      logoEl.style.cssText = `width:100%;height:auto;display:block;`;
      logoEl.draggable = false;
    } else {
      /* Fallback: white GWAK text on canvas — still looks great with the colour filter */
      logoEl = document.createElement('canvas');
      logoEl.width  = LOGO_W * 2;   /* retina */
      logoEl.height = 120;
      logoEl.style.cssText = `width:${LOGO_W}px;height:60px;display:block;`;
      const ctx = logoEl.getContext('2d');
      ctx.scale(2, 2);
      ctx.font = 'bold 52px "Arial Black", Impact, sans-serif';
      ctx.textBaseline = 'middle';
      ctx.fillStyle = '#ffffff';
      ctx.fillText('GWAK', 4, 30);
    }

    logoWrap.appendChild(logoEl);
    overlay.appendChild(logoWrap);
    document.body.appendChild(overlay);

    /* ── Apply a color by index ── */
    function applyColor(idx) {
      logoEl.style.filter = COLORS[idx].filter;
    }

    /* ── Pick a random starting angle ── */
    function randomVelocity() {
      const angle = (Math.random() * 50 + 25) * (Math.PI / 180) *
                    (Math.random() < 0.5 ? 1 : -1);
      const dir   = Math.random() < 0.5 ? 1 : -1;
      vx = Math.cos(angle) * SPEED * dir;
      vy = Math.sin(angle) * SPEED * (Math.random() < 0.5 ? 1 : -1);
    }

    /* ── Animation loop ── */
    function tick() {
      const maxX = window.innerWidth  - logoWrap.offsetWidth;
      const maxY = window.innerHeight - logoWrap.offsetHeight;

      px += vx;
      py += vy;

      let bounced = false;

      if (px <= 0)    { px = 0;    vx =  Math.abs(vx); bounced = true; }
      if (px >= maxX) { px = maxX; vx = -Math.abs(vx); bounced = true; }
      if (py <= 0)    { py = 0;    vy =  Math.abs(vy); bounced = true; }
      if (py >= maxY) { py = maxY; vy = -Math.abs(vy); bounced = true; }

      if (bounced) {
        colorIdx = (colorIdx + 1) % COLORS.length;
        applyColor(colorIdx);
      }

      logoWrap.style.left = px + 'px';
      logoWrap.style.top  = py + 'px';

      animId = requestAnimationFrame(tick);
    }

    /* ── Show / hide ── */
    function showScreensaver() {
      if (active) return;
      active = true;

      px = Math.random() * Math.max(1, window.innerWidth  - LOGO_W - 40) + 20;
      py = Math.random() * Math.max(1, window.innerHeight - 80  - 40) + 20;
      randomVelocity();

      colorIdx = Math.floor(Math.random() * COLORS.length);
      applyColor(colorIdx);

      logoWrap.style.left = px + 'px';
      logoWrap.style.top  = py + 'px';

      overlay.style.display = 'block';
      animId = requestAnimationFrame(tick);
    }

    function hideScreensaver() {
      if (!active) return;
      active = false;
      overlay.style.display = 'none';
      cancelAnimationFrame(animId);
      animId = null;
      resetIdleTimer();
    }

    /* ── Idle timer ── */
    function resetIdleTimer() {
      clearTimeout(idleTimer);
      if (!active) {
        idleTimer = setTimeout(showScreensaver, CFG.screensaverDelay);
      }
    }

    /* ── Input listeners ── */
    const WAKE_EVENTS = ['mousemove', 'mousedown', 'keydown', 'touchstart', 'wheel', 'scroll'];
    WAKE_EVENTS.forEach(evt => {
      document.addEventListener(evt, () => {
        if (active) hideScreensaver();
        else        resetIdleTimer();
      }, { passive: true });
    });

    /* clicking or touching the screensaver itself also dismisses it */
    overlay.addEventListener('click',      hideScreensaver);
    overlay.addEventListener('touchstart', hideScreensaver, { passive: true });

    /* kick off the idle countdown */
    resetIdleTimer();
  }

  /* ============================================================
     INIT
     ============================================================ */
  /* ── Giant rainbow arc in the desktop background ───────────────
     Drawn as SVG behind all icons / windows.  Always visible.    */
  function buildDesktopRainbow() {
    var ns  = 'http://www.w3.org/2000/svg';
    var svg = document.createElementNS(ns, 'svg');
    svg.id  = 'w98-rainbow-bg';
    svg.style.cssText = [
      'position:fixed', 'top:0', 'left:0',
      'width:100%', 'height:100%',
      'pointer-events:none', 'z-index:0'
    ].join(';');

    var W = window.innerWidth  || 1200;
    var H = window.innerHeight || 700;
    svg.setAttribute('viewBox', '0 0 ' + W + ' ' + H);
    svg.setAttribute('preserveAspectRatio', 'xMidYMid meet');

    var COLORS = ['#FF1A1A','#FF8800','#FFE500','#22CC22','#1199FF','#3322EE','#9911CC'];
    var cx     = W / 2;
    // radius large enough that the arc spans the full screen width
    var outerR = Math.max(W * 0.58, H * 0.92);
    // centre slightly below the screen bottom so the base is hidden
    var cy     = H + outerR * 0.06;
    var totalBand = outerR * 0.78;          // total thickness of all stripes
    var bandW     = totalBand / COLORS.length;

    // White glow / cloud base at the bottom of the rainbow
    var glow = document.createElementNS(ns, 'ellipse');
    glow.setAttribute('cx', String(cx));
    glow.setAttribute('cy', String(cy));
    glow.setAttribute('rx', String(outerR * 1.05));
    glow.setAttribute('ry', String(outerR * 0.28));
    glow.setAttribute('fill', 'rgba(255,255,255,0.18)');
    svg.appendChild(glow);

    COLORS.forEach(function(c, i) {
      var r  = outerR - i * bandW;
      var x1 = cx - r, x2 = cx + r;
      var path = document.createElementNS(ns, 'path');
      path.setAttribute('d',
        'M ' + x1.toFixed(1) + ',' + cy.toFixed(1) +
        ' A ' + r.toFixed(1) + ',' + r.toFixed(1) +
        ' 0 0,1 ' + x2.toFixed(1) + ',' + cy.toFixed(1)
      );
      path.setAttribute('stroke', c);
      path.setAttribute('stroke-width', String((bandW + 1).toFixed(1)));
      path.setAttribute('fill', 'none');
      path.setAttribute('opacity', '0.88');
      svg.appendChild(path);
    });

    desktop.insertBefore(svg, desktop.firstChild);
  }

  /* ============================================================
     ICON ATTENTION STYLES — "NEW" badge + glow, for drawing the
     eye to a specific desktop icon (e.g. announcing new merch).
     To reuse this on another icon later, just add badge/highlight
     fields to that icon's entry in CFG.icons — no CSS edits needed.
     ============================================================ */
  function injectIconAttentionStyles() {
    if (document.getElementById('w98-icon-attention-css')) return;

    const css = `
      .w98-icon { position: relative; }

      .w98-icon__badge {
        position: absolute;
        top: -4px;
        right: -4px;
        background: #cc0000;
        color: #fff;
        font-family: var(--w98-font, inherit);
        font-size: 9px;
        font-weight: bold;
        line-height: 1;
        padding: 3px 5px;
        border-radius: 8px;
        border: 1px solid #fff;
        box-shadow: 0 1px 3px rgba(0,0,0,0.45);
        pointer-events: none;
        z-index: 2;
        animation: w98-badge-pulse 1.6s ease-in-out infinite;
      }

      @keyframes w98-badge-pulse {
        0%, 100% { transform: scale(1); }
        50%      { transform: scale(1.18); }
      }

      .w98-icon--highlight .w98-icon__glyph {
        animation: w98-icon-glow 1.8s ease-in-out infinite;
      }

      @keyframes w98-icon-glow {
        0%, 100% { filter: drop-shadow(0 0 3px rgba(255, 215, 0, 0.55)); }
        50%      { filter: drop-shadow(0 0 10px rgba(255, 215, 0, 0.95)); }
      }
    `;

    const styleEl = document.createElement('style');
    styleEl.id = 'w98-icon-attention-css';
    styleEl.textContent = css;
    document.head.appendChild(styleEl);
  }

  /* ============================================================
     DEEP LINKING
     If someone lands on a real Shopify URL directly — clicks a link,
     types gwakproductions.com/collections/new-merch, opens a shared
     link, etc. — the desktop still boots first (that's the theme),
     but instead of dropping them on the bare desktop and making them
     click the icon themselves, we auto-open the matching window right
     after boot so they land straight on the content they asked for.
     ============================================================ */
  function slugToTitle(slug) {
    return slug.split('-').map(w => w.charAt(0).toUpperCase() + w.slice(1)).join(' ');
  }

  function findDeepLinkTarget(pathname) {
    const path = pathname.replace(/\/+$/, '') || '/';
    if (path === '/') return null; // homepage — just show the desktop as normal

    // Icons flagged noAutoOpen are manual-only: they should open ONLY
    // when the person clicks the desktop icon themselves, never just
    // because someone landed on/visited that URL. Check this first so
    // the catch-all fallback (step 5 below) doesn't still auto-open it.
    const manualOnlyMatch = (CFG.icons || []).find(i => i.url === path && i.noAutoOpen);
    if (manualOnlyMatch) return null;

    // 1. Collections that live as tabs inside the "My Shop" window —
    //    open that window pre-selected to the matching tab.
    if (CFG.shopTabs) {
      const idx = CFG.shopTabs.findIndex(t => t.url === path);
      if (idx !== -1) return { type: 'shopTab', idx };
    }

    // 2. Desktop icons with a direct url (Merch, Cart, Contact, etc.)
    const iconMatch = (CFG.icons || []).find(i => i.url === path);
    if (iconMatch) {
      return { type: 'page', id: 'win-deep-' + (iconMatch.id || 'icon'), title: iconMatch.label, glyph: iconMatch.glyph || '🪟', url: path };
    }

    // 3. Start-menu nav links (Home, All Art, Cart, Contact)
    const navMatch = (CFG.navItems || []).find(i => i.url === path);
    if (navMatch) {
      return { type: 'page', id: 'win-deep-nav-' + navMatch.label, title: navMatch.label, glyph: navMatch.glyph, url: path };
    }

    // 4. Legal/policy pages
    const legalMatch = (CFG.legalItems || []).find(i => i.url === path);
    if (legalMatch) {
      return { type: 'page', id: 'win-deep-legal-' + legalMatch.label, title: legalMatch.label, glyph: legalMatch.glyph, url: path };
    }

    // 4b. Product pages — if the product lives in one of the Merch tab
    //     collections (Tees, Hoodies), open the Merch window on that
    //     product WITH the tab strip, so a visitor arriving from an
    //     email link can hop to the other collections in one click.
    const pm = path.match(/^\/products\/([^\/]+)$/);
    if (pm && CFG.merchTabs && CFG.merchTabs.length) {
      return { type: 'product', handle: pm[1], url: path,
               fallback: { id: 'win-deep-' + pm[1], title: slugToTitle(pm[1]), glyph: '🏷️', url: path },
               merchIdx: findMerchTabForProduct(pm[1]) };
    }

    // 5. Fallback — any other collection, product, page, or blog URL not
    //    explicitly listed above still opens in its own window, titled
    //    from the URL slug, so a link to a one-off product or collection
    //    always lands directly on that content too.
    const m = path.match(/^\/(collections|products|pages|blogs)\/([^\/]+)/);
    if (m) {
      return { type: 'page', id: 'win-deep-' + m[2], title: slugToTitle(m[2]), glyph: m[1] === 'products' ? '🏷️' : '🖼️', url: path };
    }

    return null;
  }

  // Resolves to the index of the CFG.merchTabs collection containing this
  // product handle, or -1 (also -1 on any network error).
  function findMerchTabForProduct(handle) {
    const checks = CFG.merchTabs.map((tab, i) =>
      fetch(tab.url + '/products.json?limit=250', { credentials: 'same-origin' })
        .then(r => r.ok ? r.json() : { products: [] })
        .then(d => ((d.products || []).some(p => p.handle === handle) ? i : -1))
        .catch(() => -1)
    );
    return Promise.all(checks).then(r => r.reduce((a, b) => (a !== -1 ? a : b), -1));
  }

  function openDeepLinkTarget(target) {
    if (!target) return;
    if (target.type === 'product') {
      target.merchIdx.then(idx => {
        if (idx !== -1) openTabbedWindow({ id: 'win-merch', title: 'Merch', glyph: '🛍️',
                                           tabs: CFG.merchTabs, initialTabIdx: idx, initialUrl: target.url });
        else openPageWin(target.fallback.id, target.fallback.title, target.fallback.glyph, target.fallback.url);
      });
      return;
    }
    if (target.type === 'shopTab') { openMyShopWindow(target.idx); return; }
    openPageWin(target.id, target.title, target.glyph, target.url);
  }

  function init() {
    document.body.classList.add('w98-desktop-mode');

    injectIconAttentionStyles();
    desktop = h('div', { id: 'w98-desktop' });
    document.body.appendChild(desktop);
    buildIcons(); /* icons append directly to desktop, positions from localStorage */

    buildTaskbar();
    buildStartMenu();
    buildContextMenu();
    buildBootScreen();
    initKeyboard();
    initScreensaver();

    // Deep link: if this page load landed on a real URL for a
    // collection/product/page rather than the homepage, auto-open the
    // matching window after boot instead of leaving a bare desktop.
    // Takes priority over the generic CFG.autoOpen behavior below so we
    // don't pop two windows on top of each other.
    const deepLinkTarget = findDeepLinkTarget(location.pathname);
    const autoOpenDelay = CFG.bootScreen && !sessionStorage.getItem('w98_booted_prev') ? 5500 : 600;
    sessionStorage.setItem('w98_booted_prev', '1');

    if (deepLinkTarget) {
      setTimeout(() => openDeepLinkTarget(deepLinkTarget), autoOpenDelay);
    } else if (CFG.autoOpen) {
      // Auto-open the store collection on first load.
      // Comment this line out if you prefer a clean desktop.
      setTimeout(() => openMyShopWindow(), autoOpenDelay);
    }

    // If this page just loaded as the reload triggered by a newsletter
    // submission, reopen the popup right away showing the result instead
    // of queuing up the normal delayed auto-popup on top of it.
    const returnedFromNewsletterSubmit = handleNewsletterReturn();

    // Show newsletter popup 7 seconds after page load — but only for
    // visitors who haven't already subscribed, and aren't within the
    // "No thanks" cooldown window (see shouldShowNewsletterPopup below).
    // It can still be opened manually any time from the Start menu,
    // e.g. so a subscriber can look up the discount code again.
    if (!returnedFromNewsletterSubmit && shouldShowNewsletterPopup()) setTimeout(openNewsletterWin, 7000);
  }

  // Subscribing suppresses the auto-popup permanently (w98_nl_subscribed).
  // Clicking "No thanks" only suppresses it for NL_DISMISS_COOLDOWN_DAYS —
  // long enough not to nag on every visit, short enough that someone who
  // just wasn't ready yet still gets another shot later.
  const NL_DISMISS_COOLDOWN_DAYS = 14;

  function shouldShowNewsletterPopup() {
    try {
      if (localStorage.getItem('w98_nl_subscribed')) return false;
      const dismissedAt = parseInt(localStorage.getItem('w98_nl_dismissed_at') || '0', 10);
      if (dismissedAt) {
        const daysSince = (Date.now() - dismissedAt) / (1000 * 60 * 60 * 24);
        if (daysSince < NL_DISMISS_COOLDOWN_DAYS) return false;
      }
    } catch (e) {}
    return true;
  }

  // After a newsletter submission goes through as a real page reload (see
  // the big comment near findNativeNewsletterForm for why a reload, not a
  // background request, is what this uses), this detects that we just
  // came back from one — via a marker stashed in sessionStorage right
  // before the reload — and reopens the popup already showing the
  // result, instead of leaving the visitor looking at a bare reloaded
  // page with no explanation. Called once from init(), above.
  function handleNewsletterReturn() {
    let pending = null;
    try {
      const raw = sessionStorage.getItem(NL_PENDING_KEY);
      if (raw) pending = JSON.parse(raw);
    } catch (e) {}
    if (!pending) return false;
    try { sessionStorage.removeItem(NL_PENDING_KEY); } catch (e) {}

    // Shopify appends this to the redirect target on a successful
    // customer/contact submission; its absence is what a rejected one
    // looks like.
    const success = /(customer|contact)_posted=true/.test(location.search) ||
                     /(customer|contact)_posted=true/.test(location.hash);

    // Strip that flag out of the URL so it doesn't linger, get
    // bookmarked, or get shared with a stray query string attached.
    try {
      const url = new URL(location.href);
      url.searchParams.delete('customer_posted');
      url.searchParams.delete('contact_posted');
      history.replaceState(null, '', url.pathname + url.search);
    } catch (e) {}

    // Small delay so this doesn't fight the rest of init()'s desktop
    // setup (icons/taskbar) still running in the same tick.
    setTimeout(function () {
      openNewsletterWin({
        initialState: success ? 'success' : 'error',
        initialEmail: pending.email || '',
      });
    }, 500);
    return true;
  }

  /* ============================================================
     NEWSLETTER POPUP
     Win98-style email subscribe popup shown once per visitor.
     Uses Shopify's built-in /contact customer form endpoint.
     ============================================================ */
  // Forces this popup's size/position/scrolling directly on the element
  // with inline !important, which is the one thing that reliably beats
  // ANY external stylesheet rule (including the site's own mobile
  // "windows go full-screen" !important rule) regardless of how that
  // rule is written — no guessing at CSS specificity required.
  function pinNewsletterPopupLayout(winEl, popupW) {
    const styles = {
      position: 'fixed',
      left: '50%',
      top: '50%',
      right: 'auto',
      bottom: 'auto',
      margin: '0',
      transform: 'translate(-50%, -50%)',
      width: popupW + 'px',
      'max-width': 'calc(100vw - 32px)',
      height: 'auto',
      'max-height': 'calc(100vh - 40px)',
      'overflow-y': 'auto',
      'overflow-x': 'hidden',
    };
    Object.entries(styles).forEach(([prop, val]) => {
      winEl.style.setProperty(prop, val, 'important');
    });
  }

  // Subtle "pay attention to me" treatment for the popup: a soft pulsing
  // glow around the window frame, a small accent-colored badge pill above
  // the headline, and a warmer call-to-action button — all understated,
  // reusing the same red/gold tones as the Merch icon's own badge/glow so
  // it feels like one consistent design language rather than a new one.
  function injectNewsletterAccentStyles() {
    if (document.getElementById('w98-nl-accent-css')) return;
    const css = `
      @keyframes w98-nl-window-glow {
        0%, 100% { box-shadow: 0 0 10px 2px rgba(40, 210, 90, 0.45), 2px 2px 8px rgba(0,0,0,0.4); }
        50%      { box-shadow: 0 0 22px 7px rgba(40, 210, 90, 0.80), 2px 2px 8px rgba(0,0,0,0.4); }
      }
      #w98-newsletter { animation: w98-nl-window-glow 2.6s ease-in-out infinite; }

      .w98-nl-badge {
        display: inline-block;
        background: linear-gradient(180deg, #e6392b, #b0221a);
        color: #fff;
        font-family: var(--w98-font, inherit);
        font-size: 11px;
        font-weight: bold;
        letter-spacing: 0.3px;
        padding: 3px 10px;
        border-radius: 10px;
        border: 1px solid #fff;
        box-shadow: 0 1px 3px rgba(0,0,0,0.35);
        margin-bottom: 6px;
      }

      .w98-nl-cta {
        background: linear-gradient(180deg, #e6392b, #b0221a) !important;
        color: #fff !important;
        border: 2px outset #ff8a75 !important;
        font-weight: bold !important;
        text-shadow: 0 1px 1px rgba(0,0,0,0.25);
      }
      .w98-nl-cta:hover { filter: brightness(1.08); }
      .w98-nl-cta:active { filter: brightness(0.95); }
    `;
    const styleEl = document.createElement('style');
    styleEl.id = 'w98-nl-accent-css';
    styleEl.textContent = css;
    document.head.appendChild(styleEl);
  }

  /* ============================================================
     Newsletter form submission — real top-level navigation
     Three background-submission approaches were tried and ruled out by
     direct testing on this store: fetch()/XHR (Shopify's /contact
     endpoint requires a CAPTCHA token specifically for requests that
     look scripted — a real 400 "Missing CAPTCHA token" error), a
     hidden <iframe> (this store sends a CSP frame-ancestors /
     X-Frame-Options header that refuses to load ANY of its pages
     inside an iframe at all, which is also why the rest of this file
     fetches + injects page HTML instead of using real iframes — see
     the file header comment), and a background popup window (opened
     fine, but never completed navigating — most likely another
     cross-origin isolation header silently blocking it).

     Every one of those exists specifically to make it hard for a
     script to submit this form invisibly, so the only reliable way
     left is the one they're built to allow: a real, visible, top-level
     form submission — exactly like a visitor using the footer's own
     newsletter form directly. sessionStorage carries a small marker
     across that reload so init() (below) can detect the return trip
     and reopen this popup already showing the result, instead of
     leaving the visitor looking at a bare reloaded page.
     ============================================================ */
  const NL_PENDING_KEY = 'w98_nl_pending';

  // Finds Shopify's own native newsletter/customer form already rendered
  // somewhere on the page (Dawn ships one in the footer's "Email signup"
  // section by default). We prefer hijacking that real, Shopify-rendered
  // form over building our own from scratch: whatever anti-spam handling
  // Shopify's platform requires gets attached to it automatically at
  // render time, which is something no hand-built form can fake.
  function findNativeNewsletterForm() {
    const candidates = document.querySelectorAll('form[action*="/contact"]');
    for (let i = 0; i < candidates.length; i++) {
      const f = candidates[i];
      const typeInput = f.querySelector('input[name="form_type"]');
      const emailInput = f.querySelector('input[name="contact[email]"]');
      if (emailInput && (!typeInput || typeInput.value === 'customer')) return f;
    }
    return null;
  }

  // Fills Shopify's real footer newsletter form with our popup's values
  // and submits *that* form as a normal, full top-level page load. Extra
  // fields we need that the native form doesn't already have (phone,
  // SMS-consent tag) are appended as hidden inputs — left in place
  // afterward since the page is navigating away regardless.
  function submitViaNativeForm(nativeForm, data) {
    const tag = '[GWAK newsletter/native-form]';
    const emailInput = nativeForm.querySelector('input[name="contact[email]"]');
    if (!emailInput) {
      console.error(tag, 'native form found but has no contact[email] input inside it:', nativeForm);
      return false;
    }

    function fillAndSubmit() {
      emailInput.value = data.email;

      function ensureHidden(name, value) {
        let inputEl = nativeForm.querySelector('input[name="' + name.replace(/"/g, '\\"') + '"]');
        if (!inputEl) {
          inputEl = document.createElement('input');
          inputEl.type = 'hidden';
          inputEl.name = name;
          nativeForm.appendChild(inputEl);
        }
        inputEl.value = value;
      }

      ensureHidden('contact[accepts_marketing]', '1');
      const tagsInput = nativeForm.querySelector('input[name="contact[tags]"]');
      const existingTags = tagsInput ? tagsInput.value : '';
      const tagParts = existingTags ? existingTags.split(',').map(function (s) { return s.trim(); }).filter(Boolean) : [];
      if (tagParts.indexOf('newsletter') === -1) tagParts.push('newsletter');
      if (data.smsOptIn && tagParts.indexOf('sms-optin') === -1) tagParts.push('sms-optin');
      ensureHidden('contact[tags]', tagParts.join(', '));
      if (data.phone) ensureHidden('contact[phone]', data.phone);

      // Make sure it navigates THIS tab — not some leftover target
      // attribute from an earlier experiment (belt-and-suspenders).
      nativeForm.removeAttribute('target');

      try { sessionStorage.setItem(NL_PENDING_KEY, JSON.stringify({ email: data.email })); } catch (e) {}
      console.log(tag, 'CAPTCHA ready (or unavailable) — submitting native form as a real top-level navigation — email:', data.email);
      nativeForm.submit();
    }

    // THE ACTUAL FIX: Shopify's hCaptcha only attaches itself to a form
    // once it sees a real user interact with that form (focus/click/type
    // on a field) — per https://shopify.dev/docs/storefronts/themes/trust-security/captcha.
    // Every previous attempt set the email value with plain JS and never
    // triggered real interaction, so hCaptcha never wired up on the form
    // at all, and its token was never generated — that's the actual root
    // cause of "Missing CAPTCHA token" every single time, independent of
    // fetch/iframe/popup/reload. Shopify ships window.Shopify.captcha.protect()
    // specifically for this: programmatically-driven form submissions.
    if (window.Shopify && window.Shopify.captcha && typeof window.Shopify.captcha.protect === 'function') {
      console.log(tag, 'calling window.Shopify.captcha.protect() to force CAPTCHA wire-up before submitting');
      window.Shopify.captcha.protect(nativeForm, fillAndSubmit);
    } else {
      console.warn(tag, 'window.Shopify.captcha.protect is not available — submitting without forcing CAPTCHA wire-up; this may still fail');
      fillAndSubmit();
    }
    return true;
  }

  // Fallback used only if no native Shopify form exists anywhere on the
  // page to hijack. Builds a plain form with the same fields and submits
  // it the same way — as a real top-level navigation.
  function submitHandBuiltForm(action, fields) {
    const tag = '[GWAK newsletter/hand-built]';
    const form = document.createElement('form');
    form.action = action;
    form.method = 'post';
    form.style.display = 'none';
    form.acceptCharset = 'UTF-8';

    Object.keys(fields).forEach(function (key) {
      if (fields[key] === undefined || fields[key] === null) return;
      const inputEl = document.createElement('input');
      inputEl.type = 'hidden';
      inputEl.name = key;
      inputEl.value = fields[key];
      form.appendChild(inputEl);
    });

    try { sessionStorage.setItem(NL_PENDING_KEY, JSON.stringify({ email: fields['contact[email]'] || '' })); } catch (e) {}
    document.body.appendChild(form);

    // Same fix as submitViaNativeForm above: force Shopify's hCaptcha to
    // wire up on this form before submitting, since it only does so on
    // real user interaction otherwise — which a hand-built, hidden form
    // never gets.
    if (window.Shopify && window.Shopify.captcha && typeof window.Shopify.captcha.protect === 'function') {
      console.log(tag, 'calling window.Shopify.captcha.protect() to force CAPTCHA wire-up before submitting to', action);
      window.Shopify.captcha.protect(form, function () { form.submit(); });
    } else {
      console.warn(tag, 'window.Shopify.captcha.protect is not available — submitting without forcing CAPTCHA wire-up; this may still fail');
      console.log(tag, 'submitting hand-built form as a real top-level navigation to', action);
      form.submit();
    }
  }

  // `opts.initialState` ('success' | 'error') and `opts.initialEmail` let
  // this be reopened already showing the result of a submission that just
  // happened via a real page reload (see handleNewsletterReturn / init
  // below) instead of always starting at the empty form.
  function openNewsletterWin(opts) {
    const WIN_ID = 'w98-newsletter';
    if (wins.has(WIN_ID)) { restoreWin(WIN_ID); return; }

    // All the wording below comes from CFG.newsletterPopup near the top
    // of this file — edit it there, not here, to change what shows up.
    const NL = Object.assign({
      headline: 'GWAK PRODUCTIONS',
      body: 'Get insider news, product launches, and more.',
      emailPlaceholder: 'your@email.com',
      phonePlaceholder: 'Phone number (optional)',
      smsConsentText: 'Also text me exclusive drops & offers. Msg & data rates may apply, frequency varies. Consent isn\'t required to purchase. Reply STOP anytime to opt out.',
      buttonLabel: 'Subscribe',
      skipLabel: 'No thanks',
      successText: 'You\'re subscribed!',
      discountCode: '',
      badgeText: '',
    }, CFG.newsletterPopup || {});

    injectNewsletterAccentStyles();

    // Small helper so any text pasted into CFG.newsletterPopup can't
    // accidentally break the popup's HTML.
    const escHtml = (str) => String(str)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');

    // Builds the success message with the discount code visually
    // highlighted (bold, on a light badge) plus a one-tap "Copy" button,
    // instead of making them manually select and copy the text.
    function buildSuccessHtml() {
      const parts = NL.successText.split('{code}');
      if (parts.length === 2 && NL.discountCode) {
        return escHtml(parts[0]) +
          '<strong style="background:#fff3c4;padding:1px 6px;border:1px solid #c9a227;border-radius:2px;">' +
          escHtml(NL.discountCode) + '</strong> ' +
          '<button type="button" id="w98-nl-copy-btn" style="font-family:var(--w98-font, inherit);' +
          'font-size:10px;padding:2px 8px;cursor:pointer;background:#c0c0c0;border:1px outset #fff;' +
          'vertical-align:middle;">Copy</button>' +
          escHtml(parts[1]);
      }
      return escHtml(NL.successText.replace(/\{code\}/g, NL.discountCode));
    }

    // Copies text to the clipboard, with a fallback for browsers/contexts
    // where the modern clipboard API isn't available.
    function copyTextToClipboard(text, onDone) {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(onDone).catch(function () {
          fallbackCopyText(text, onDone);
        });
      } else {
        fallbackCopyText(text, onDone);
      }
    }
    function fallbackCopyText(text, onDone) {
      try {
        const ta = document.createElement('textarea');
        ta.value = text;
        ta.style.position = 'fixed';
        ta.style.left = '-9999px';
        document.body.appendChild(ta);
        ta.focus();
        ta.select();
        document.execCommand('copy');
        document.body.removeChild(ta);
      } catch (e) {}
      if (onDone) onDone();
    }

    const body = document.createElement('div');
    body.style.cssText = 'display:flex;flex-direction:column;gap:8px;padding:16px 16px 28px 16px;font-family:var(--w98-font);font-size:12px;';

    body.innerHTML = `
      <div style="text-align:center;margin-bottom:2px;">
        ${NL.badgeText ? `<div class="w98-nl-badge">${escHtml(NL.badgeText)}</div>` : ''}
        <div style="font-size:28px;margin-bottom:4px;">📬</div>
        <div style="font-weight:bold;font-size:13px;">${escHtml(NL.headline)}</div>
        <div style="color:#444;margin-top:4px;">${escHtml(NL.body)}</div>
      </div>

      <input id="w98-nl-email" type="email" placeholder="${escHtml(NL.emailPlaceholder)}"
        style="width:100%;box-sizing:border-box;padding:5px 6px;font-family:var(--w98-font);font-size:12px;
               border:2px inset #888;background:#fff;"/>

      <input id="w98-nl-phone" type="tel" placeholder="${escHtml(NL.phonePlaceholder)}"
        style="width:100%;box-sizing:border-box;padding:5px 6px;font-family:var(--w98-font);font-size:12px;
               border:2px inset #888;background:#fff;"/>

      <label style="display:flex;align-items:flex-start;gap:6px;cursor:pointer;color:#333;line-height:1.35;">
        <input id="w98-nl-sms-optin" type="checkbox"
          style="margin-top:2px;flex-shrink:0;"/>
        <span style="font-size:10.5px;">${escHtml(NL.smsConsentText)}</span>
      </label>

      <button id="w98-nl-submit" type="button" class="w98-nl-cta"
        style="width:100%;padding:7px 10px;font-family:var(--w98-font);font-size:12px;cursor:pointer;">
        ${escHtml(NL.buttonLabel)}
      </button>

      <div id="w98-nl-status" style="min-height:16px;color:#333;text-align:center;"></div>
      <div style="text-align:center;margin-top:-4px;">
        <button id="w98-nl-skip" type="button"
          style="background:none;border:none;color:#555;font-family:var(--w98-font);
                 font-size:11px;cursor:pointer;text-decoration:underline;">
          ${escHtml(NL.skipLabel)}
        </button>
      </div>
    `;

    // Play notification sound when popup appears
    try {
      var nlSound = new Audio('https://archive.org/download/windows-95-sounds/Windows%2095%20Notify.wav');
      nlSound.volume = 0.7;
      nlSound.play().catch(function() {
        // fallback to Windows beep if notify sound fails
        playWindowsBeep();
      });
    } catch(e) { playWindowsBeep(); }

    const popupW = Math.min(320, window.innerWidth - 32);
    const popupH = Math.min(360, window.innerHeight - 60);
    const popupX = Math.max(8, (window.innerWidth  - popupW) / 2);
    const popupY = Math.max(8, (window.innerHeight - popupH) / 2);

    _openWin({
      id: WIN_ID,
      title: 'GWAK PRODUCTIONS',
      glyph: '📬',
      body,
      pos: { x: popupX, y: popupY },
      w: popupW,
      h: popupH,
      forceSize: true,
    });

    // Belt-and-suspenders: force the final size/position/scroll directly
    // on the element so nothing in the site's own stylesheet (including
    // its mobile "go full-screen" rule) can override it.
    const nlWinEl = document.getElementById(WIN_ID);
    if (nlWinEl) pinNewsletterPopupLayout(nlWinEl, popupW);

    const emailEl   = document.getElementById('w98-nl-email');
    const phoneEl   = document.getElementById('w98-nl-phone');
    const smsOptEl  = document.getElementById('w98-nl-sms-optin');
    const statusEl  = document.getElementById('w98-nl-status');
    const submitBtn = document.getElementById('w98-nl-submit');
    const skipBtn   = document.getElementById('w98-nl-skip');

    // Shared so both a fresh submission (below) and reopening this popup
    // after the post-submit page reload (see handleNewsletterReturn) can
    // render the exact same success view.
    function showSuccessState() {
      if (statusEl) statusEl.innerHTML = '<span style="color:#006600;">✔ ' + buildSuccessHtml() + '</span>';
      if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = 'SENT!'; }
      try { localStorage.setItem('w98_nl_subscribed', '1'); } catch(e) {} // subscribed — don't show again, ever

      const copyBtn = document.getElementById('w98-nl-copy-btn');
      if (copyBtn) {
        copyBtn.addEventListener('click', function () {
          copyTextToClipboard(NL.discountCode, function () {
            copyBtn.textContent = 'Copied!';
            setTimeout(function () { copyBtn.textContent = 'Copy'; }, 1500);
          });
        });
      }

      // Give them time to actually read/copy the code before auto-closing
      // (or don't auto-close at all if there's a code to note down).
      if (!NL.discountCode) setTimeout(function() { closeWin(WIN_ID); }, 2000);
    }

    function doSubscribe() {
      const email = emailEl ? emailEl.value.trim() : '';
      const phone = phoneEl ? phoneEl.value.trim() : '';
      const smsOptIn = !!(smsOptEl && smsOptEl.checked);

      if (!email || !/^[^@]+@[^@]+\.[^@]+$/.test(email)) {
        if (statusEl) statusEl.textContent = '⚠ Please enter a valid email address.';
        if (emailEl) emailEl.focus();
        return;
      }
      // Phone is optional, but if they typed something, make sure it's a
      // plausible number (at least 7 digits) rather than silently dropping it.
      if (phone && phone.replace(/\D/g, '').length < 7) {
        if (statusEl) statusEl.textContent = '⚠ That phone number looks incomplete.';
        if (phoneEl) phoneEl.focus();
        return;
      }

      if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = 'Sending…'; }
      if (statusEl) statusEl.textContent = '';

      // Prefer hijacking Shopify's own native newsletter form (Dawn's
      // footer "Email signup" section) if one is on the page — it carries
      // whatever anti-spam handling Shopify's platform requires, which a
      // form we construct ourselves cannot fake. This submits as a real,
      // visible top-level page reload (see the big comment above
      // findNativeNewsletterForm for why every background-submission
      // trick we tried was a dead end on this store) — the page will
      // reload and this popup reopens automatically showing the result
      // (handleNewsletterReturn, called from init()).
      const nativeForm = findNativeNewsletterForm();
      const data = { email: email, phone: phone, smsOptIn: smsOptIn };

      let handled = nativeForm ? submitViaNativeForm(nativeForm, data) : false;
      if (!handled) {
        console.warn('[GWAK newsletter] No usable native Shopify newsletter form found on page — falling back to a hand-built form.');
        const tags = smsOptIn ? 'newsletter, sms-optin' : 'newsletter';
        const fields = {
          form_type: 'customer',
          utf8: '✓',
          'contact[email]': email,
          'contact[accepts_marketing]': '1',
          'contact[tags]': tags,
        };
        if (phone) fields['contact[phone]'] = phone;
        submitHandBuiltForm('/contact', fields);
      }

      // Both submit paths trigger a real page navigation, so control
      // normally never reaches this point before the browser starts
      // unloading. This is only a safety net for the rare case where
      // that navigation gets silently blocked — without it, a blocked
      // submission would leave the button stuck on "Sending…" forever.
      setTimeout(function () {
        if (submitBtn && submitBtn.textContent === 'Sending…') {
          submitBtn.disabled = false;
          submitBtn.textContent = NL.buttonLabel;
          if (statusEl) statusEl.textContent = '⚠ Something went wrong. Try again.';
        }
      }, 4000);
    }

    if (submitBtn) submitBtn.addEventListener('click', doSubscribe);
    if (emailEl) emailEl.addEventListener('keydown', function(e) { if (e.key === 'Enter') doSubscribe(); });
    if (phoneEl) phoneEl.addEventListener('keydown', function(e) { if (e.key === 'Enter') doSubscribe(); });
    if (skipBtn) skipBtn.addEventListener('click', function() {
      // Dismissed — hold off for NL_DISMISS_COOLDOWN_DAYS, not forever.
      try { localStorage.setItem('w98_nl_dismissed_at', String(Date.now())); } catch(e) {}
      closeWin(WIN_ID);
    });

    // Reopening after the post-submit page reload — show the result
    // immediately instead of the empty form.
    if (opts && opts.initialEmail && emailEl) emailEl.value = opts.initialEmail;
    if (opts && opts.initialState === 'success') {
      showSuccessState();
    } else if (opts && opts.initialState === 'error') {
      if (statusEl) statusEl.textContent = '⚠ Something went wrong. Try again.';
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  /* ============================================================
     PUBLIC API
     ============================================================ */
  window.W98 = {
    openPage:    (id, title, glyph, url) => openPageWin(id, title, glyph, url),
    close:       closeWin,
    minimize:    minimizeWin,
    restore:     restoreWin,
    toggleMax,
    showDesktop,
    openAbout,
    openRecycleBin,
    openModelingPhotos,
    openGwakNudes,
    openHeatherFolder,
    openHeatherPlayer,
    openCommissions,
    openYouTube,
    openEggGame,
  };

})();